/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.StateProvince_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.StateProvince domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum StateProvince_ {
   /// <summary>
   ///    ()
   /// </summary>
   Unknown = 0,
   /// <summary>
   ///   Burgenland, Austria (B, AT)
   /// </summary>
   B_AT = 1,
   /// <summary>
   ///   Corinthia, Austria (K, AT)
   /// </summary>
   K_AT = 2,
   /// <summary>
   ///   Lower Austria, Austria (NÖ, AT)
   /// </summary>
   NO_AT = 3,
   /// <summary>
   ///   Upper Austria, Austria (OÖ, AT)
   /// </summary>
   OO_AT = 4,
   /// <summary>
   ///   Salzburg, Austria (S, AT)
   /// </summary>
   S_AT = 5,
   /// <summary>
   ///   Styria, Austria (ST, AT)
   /// </summary>
   ST_AT = 6,
   /// <summary>
   ///   Tyrol, Austria (T, AT)
   /// </summary>
   T_AT = 7,
   /// <summary>
   ///   Vorarlberg, Austria (V, AT)
   /// </summary>
   V_AT = 8,
   /// <summary>
   ///   Vienna, Austria (W, AT)
   /// </summary>
   W_AT = 9,
   /// <summary>
   ///   Aust Capital Terr, Australia (ACT, AU)
   /// </summary>
   ACT_AU = 10,
   /// <summary>
   ///   New South Wales, Australia (NSW, AU)
   /// </summary>
   NSW_AU = 11,
   /// <summary>
   ///   Northern Territory, Australia (NT, AU)
   /// </summary>
   NT_AU = 12,
   /// <summary>
   ///   Queensland, Australia (QLD, AU)
   /// </summary>
   QLD_AU = 13,
   /// <summary>
   ///   South Australia, Australia (SA, AU)
   /// </summary>
   SA_AU = 14,
   /// <summary>
   ///   Tasmania, Australia (TAS, AU)
   /// </summary>
   TAS_AU = 15,
   /// <summary>
   ///   Victoria, Australia (VIC, AU)
   /// </summary>
   VIC_AU = 16,
   /// <summary>
   ///   Western Australia, Australia (WA, AU)
   /// </summary>
   WA_AU = 17,
   /// <summary>
   ///   Alberta, Canada (AB, CA)
   /// </summary>
   AB_CA = 19,
   /// <summary>
   ///   British Columbia, Canada (BC, CA)
   /// </summary>
   BC_CA = 20,
   /// <summary>
   ///   Manitoba, Canada (MB, CA)
   /// </summary>
   MB_CA = 21,
   /// <summary>
   ///   New Brunswick, Canada (NB, CA)
   /// </summary>
   NB_CA = 22,
   /// <summary>
   ///   Newfoundland, Canada (NL, CA)
   /// </summary>
   NL_CA = 23,
   /// <summary>
   ///   Nova Scotia, Canada (NS, CA)
   /// </summary>
   NS_CA = 24,
   /// <summary>
   ///   Northwest Territory, Canada (NT, CA)
   /// </summary>
   NT_CA = 25,
   /// <summary>
   ///   Nunavut, Canada (NU, CA)
   /// </summary>
   NU_CA = 26,
   /// <summary>
   ///   Ontario, Canada (ON, CA)
   /// </summary>
   ON_CA = 27,
   /// <summary>
   ///   Prince Edward Island, Canada (PE, CA)
   /// </summary>
   PE_CA = 28,
   /// <summary>
   ///   Quebec, Canada (QC, CA)
   /// </summary>
   QC_CA = 29,
   /// <summary>
   ///   Saskatchewan, Canada (SK, CA)
   /// </summary>
   SK_CA = 30,
   /// <summary>
   ///   Yukon, Canada (YT, CA)
   /// </summary>
   YT_CA = 31,
   /// <summary>
   ///   Outside Province/can, Canada (ZZ, CA)
   /// </summary>
   ZZ_CA = 32,
   /// <summary>
   ///   Aargau, Switzerland (AG, CH)
   /// </summary>
   AG_CH = 33,
   /// <summary>
   ///   Appenzell Innerrh, Switzerland (AI, CH)
   /// </summary>
   AI_CH = 34,
   /// <summary>
   ///   Appenzell Ausserrh., Switzerland (AR, CH)
   /// </summary>
   AR_CH = 35,
   /// <summary>
   ///   Bern, Switzerland (BE, CH)
   /// </summary>
   BE_CH = 36,
   /// <summary>
   ///   Basel Land, Switzerland (BL, CH)
   /// </summary>
   BL_CH = 37,
   /// <summary>
   ///   Basel Stadt, Switzerland (BS, CH)
   /// </summary>
   BS_CH = 38,
   /// <summary>
   ///   Fribourg, Switzerland (FR, CH)
   /// </summary>
   FR_CH = 39,
   /// <summary>
   ///   Geneva, Switzerland (GE, CH)
   /// </summary>
   GE_CH = 40,
   /// <summary>
   ///   Glarus, Switzerland (GL, CH)
   /// </summary>
   GL_CH = 41,
   /// <summary>
   ///   Graubuenden, Switzerland (GR, CH)
   /// </summary>
   GR_CH = 42,
   /// <summary>
   ///   Jura, Switzerland (JU, CH)
   /// </summary>
   JU_CH = 43,
   /// <summary>
   ///   Lucerne, Switzerland (LU, CH)
   /// </summary>
   LU_CH = 44,
   /// <summary>
   ///   Neuchatel, Switzerland (NE, CH)
   /// </summary>
   NE_CH = 45,
   /// <summary>
   ///   Nidwalden, Switzerland (NW, CH)
   /// </summary>
   NW_CH = 46,
   /// <summary>
   ///   Obwalden, Switzerland (OW, CH)
   /// </summary>
   OW_CH = 47,
   /// <summary>
   ///   St. Gallen, Switzerland (SG, CH)
   /// </summary>
   SG_CH = 48,
   /// <summary>
   ///   Schaffhausen, Switzerland (SH, CH)
   /// </summary>
   SH_CH = 49,
   /// <summary>
   ///   Solothurn, Switzerland (SO, CH)
   /// </summary>
   SO_CH = 50,
   /// <summary>
   ///   Switzerland, Switzerland (SZ, CH)
   /// </summary>
   SZ_CH = 51,
   /// <summary>
   ///   Thurgau, Switzerland (TG, CH)
   /// </summary>
   TG_CH = 52,
   /// <summary>
   ///   Ticino, Switzerland (TI, CH)
   /// </summary>
   TI_CH = 53,
   /// <summary>
   ///   Uri, Switzerland (UR, CH)
   /// </summary>
   UR_CH = 54,
   /// <summary>
   ///   Vaud, Switzerland (VD, CH)
   /// </summary>
   VD_CH = 55,
   /// <summary>
   ///   Valais, Switzerland (VS, CH)
   /// </summary>
   VS_CH = 56,
   /// <summary>
   ///   Zug, Switzerland (ZG, CH)
   /// </summary>
   ZG_CH = 57,
   /// <summary>
   ///   Zurich, Switzerland (ZH, CH)
   /// </summary>
   ZH_CH = 58,
   /// <summary>
   ///   Armagh, United Kingdom (AM, GB)
   /// </summary>
   AM_GB = 287,
   /// <summary>
   ///   Ards, United Kingdom (AR, GB)
   /// </summary>
   AR_GB = 288,
   /// <summary>
   ///   Antrim, United Kingdom (AT, GB)
   /// </summary>
   AT_GB = 289,
   /// <summary>
   ///   Ballymena, United Kingdom (BA, GB)
   /// </summary>
   BA_GB = 290,
   /// <summary>
   ///   Blackburn, United Kingdom (BB, GB)
   /// </summary>
   BB_GB = 291,
   /// <summary>
   ///   Bedfordshire, United Kingdom (BE, GB)
   /// </summary>
   BE_GB = 292,
   /// <summary>
   ///   Bracknell Forest, United Kingdom (BF, GB)
   /// </summary>
   BF_GB = 293,
   /// <summary>
   ///   Brighton & Hove, United Kingdom (BH, GB)
   /// </summary>
   BH_GB = 294,
   /// <summary>
   ///   Berkshire, United Kingdom (BK, GB)
   /// </summary>
   BK_GB = 295,
   /// <summary>
   ///   Belfast, United Kingdom (BL, GB)
   /// </summary>
   BL_GB = 296,
   /// <summary>
   ///   Bournemouth, United Kingdom (BM, GB)
   /// </summary>
   BM_GB = 297,
   /// <summary>
   ///   Banbridge, United Kingdom (BN, GB)
   /// </summary>
   BN_GB = 298,
   /// <summary>
   ///   Borders, United Kingdom (BO, GB)
   /// </summary>
   BO_GB = 299,
   /// <summary>
   ///   Blackpool, United Kingdom (BP, GB)
   /// </summary>
   BP_GB = 300,
   /// <summary>
   ///   Bristol, United Kingdom (BR, GB)
   /// </summary>
   BR_GB = 301,
   /// <summary>
   ///   Bath&nthestsomerset, United Kingdom (BS, GB)
   /// </summary>
   BS_GB = 302,
   /// <summary>
   ///   Buckinghamshire, United Kingdom (BU, GB)
   /// </summary>
   BU_GB = 303,
   /// <summary>
   ///   Ballymoney, United Kingdom (BY, GB)
   /// </summary>
   BY_GB = 304,
   /// <summary>
   ///   Cambridgeshire, United Kingdom (CA, GB)
   /// </summary>
   CA_GB = 305,
   /// <summary>
   ///   Central, United Kingdom (CE, GB)
   /// </summary>
   CE_GB = 306,
   /// <summary>
   ///   Craigavon, United Kingdom (CG, GB)
   /// </summary>
   CG_GB = 307,
   /// <summary>
   ///   Cheshire, United Kingdom (CH, GB)
   /// </summary>
   CH_GB = 308,
   /// <summary>
   ///   Coleraine, United Kingdom (CI, GB)
   /// </summary>
   CI_GB = 309,
   /// <summary>
   ///   Cookstown, United Kingdom (CK, GB)
   /// </summary>
   CK_GB = 310,
   /// <summary>
   ///   Clwyd, United Kingdom (CL, GB)
   /// </summary>
   CL_GB = 311,
   /// <summary>
   ///   Cornwall, United Kingdom (CO, GB)
   /// </summary>
   CO_GB = 312,
   /// <summary>
   ///   Carrickfergus, United Kingdom (CR, GB)
   /// </summary>
   CR_GB = 313,
   /// <summary>
   ///   Castlereagh, United Kingdom (CS, GB)
   /// </summary>
   CS_GB = 314,
   /// <summary>
   ///   Cumbria, United Kingdom (CU, GB)
   /// </summary>
   CU_GB = 315,
   /// <summary>
   ///   Cleveland, United Kingdom (CV, GB)
   /// </summary>
   CV_GB = 316,
   /// <summary>
   ///   Derbyshire, United Kingdom (DB, GB)
   /// </summary>
   DB_GB = 317,
   /// <summary>
   ///   Dumfries A. Galloway, United Kingdom (DF, GB)
   /// </summary>
   DF_GB = 318,
   /// <summary>
   ///   Dungannon, United Kingdom (DG, GB)
   /// </summary>
   DG_GB = 319,
   /// <summary>
   ///   Darlington, United Kingdom (DL, GB)
   /// </summary>
   DL_GB = 320,
   /// <summary>
   ///   Down, United Kingdom (DN, GB)
   /// </summary>
   DN_GB = 321,
   /// <summary>
   ///   Dorset, United Kingdom (DO, GB)
   /// </summary>
   DO_GB = 322,
   /// <summary>
   ///   Durham, United Kingdom (DU, GB)
   /// </summary>
   DU_GB = 323,
   /// <summary>
   ///   Devon, United Kingdom (DV, GB)
   /// </summary>
   DV_GB = 324,
   /// <summary>
   ///   Dyfed, United Kingdom (DY, GB)
   /// </summary>
   DY_GB = 325,
   /// <summary>
   ///   East Riding, United Kingdom (ER, GB)
   /// </summary>
   ER_GB = 326,
   /// <summary>
   ///   Essex, United Kingdom (ES, GB)
   /// </summary>
   ES_GB = 327,
   /// <summary>
   ///   Fife, United Kingdom (FI, GB)
   /// </summary>
   FI_GB = 328,
   /// <summary>
   ///   Fermanagh, United Kingdom (FM, GB)
   /// </summary>
   FM_GB = 329,
   /// <summary>
   ///   Gloucestershire, United Kingdom (GL, GB)
   /// </summary>
   GL_GB = 330,
   /// <summary>
   ///   Greater Manchester, United Kingdom (GM, GB)
   /// </summary>
   GM_GB = 331,
   /// <summary>
   ///   Grampian, United Kingdom (GR, GB)
   /// </summary>
   GR_GB = 332,
   /// <summary>
   ///   Sth. Gloucestershire, United Kingdom (GS, GB)
   /// </summary>
   GS_GB = 333,
   /// <summary>
   ///   Gwent, United Kingdom (GW, GB)
   /// </summary>
   GW_GB = 334,
   /// <summary>
   ///   Gwynedd, United Kingdom (GY, GB)
   /// </summary>
   GY_GB = 335,
   /// <summary>
   ///   Hampshire, United Kingdom (HA, GB)
   /// </summary>
   HA_GB = 336,
   /// <summary>
   ///   Highland, United Kingdom (HI, GB)
   /// </summary>
   HI_GB = 337,
   /// <summary>
   ///   Halton, United Kingdom (HL, GB)
   /// </summary>
   HL_GB = 338,
   /// <summary>
   ///   Hartlepool, United Kingdom (HR, GB)
   /// </summary>
   HR_GB = 339,
   /// <summary>
   ///   Hertfordshire, United Kingdom (HT, GB)
   /// </summary>
   HT_GB = 340,
   /// <summary>
   ///   Herefd. And Worcest., United Kingdom (HW, GB)
   /// </summary>
   HW_GB = 341,
   /// <summary>
   ///   Isle Of Wight, United Kingdom (IW, GB)
   /// </summary>
   IW_GB = 342,
   /// <summary>
   ///   Kent, United Kingdom (KE, GB)
   /// </summary>
   KE_GB = 343,
   /// <summary>
   ///   Kingston-Upon-Hull, United Kingdom (KH, GB)
   /// </summary>
   KH_GB = 344,
   /// <summary>
   ///   Lancashire, United Kingdom (LA, GB)
   /// </summary>
   LA_GB = 345,
   /// <summary>
   ///   Leicester City, United Kingdom (LC, GB)
   /// </summary>
   LC_GB = 346,
   /// <summary>
   ///   Londonderry, United Kingdom (LD, GB)
   /// </summary>
   LD_GB = 347,
   /// <summary>
   ///   Leicestershire, United Kingdom (LE, GB)
   /// </summary>
   LE_GB = 348,
   /// <summary>
   ///   Lincolnshire, United Kingdom (LI, GB)
   /// </summary>
   LI_GB = 349,
   /// <summary>
   ///   Limavady, United Kingdom (LM, GB)
   /// </summary>
   LM_GB = 350,
   /// <summary>
   ///   Greater London, United Kingdom (LO, GB)
   /// </summary>
   LO_GB = 351,
   /// <summary>
   ///   Larne, United Kingdom (LR, GB)
   /// </summary>
   LR_GB = 352,
   /// <summary>
   ///   Lisburn, United Kingdom (LS, GB)
   /// </summary>
   LS_GB = 353,
   /// <summary>
   ///   Lothian, United Kingdom (LT, GB)
   /// </summary>
   LT_GB = 354,
   /// <summary>
   ///   Luton, United Kingdom (LU, GB)
   /// </summary>
   LU_GB = 355,
   /// <summary>
   ///   Magherafelt, United Kingdom (MA, GB)
   /// </summary>
   MA_GB = 356,
   /// <summary>
   ///   Mid Glamorgan, United Kingdom (MG, GB)
   /// </summary>
   MG_GB = 357,
   /// <summary>
   ///   Middlesbrough, United Kingdom (MI, GB)
   /// </summary>
   MI_GB = 358,
   /// <summary>
   ///   Milton Keynes, United Kingdom (MK, GB)
   /// </summary>
   MK_GB = 359,
   /// <summary>
   ///   Moyle, United Kingdom (MO, GB)
   /// </summary>
   MO_GB = 360,
   /// <summary>
   ///   Merseyside, United Kingdom (MY, GB)
   /// </summary>
   MY_GB = 361,
   /// <summary>
   ///   Newtownabbey, United Kingdom (NA, GB)
   /// </summary>
   NA_GB = 362,
   /// <summary>
   ///   Newbury, United Kingdom (NB, GB)
   /// </summary>
   NB_GB = 363,
   /// <summary>
   ///   Nottingham City, United Kingdom (NC, GB)
   /// </summary>
   NC_GB = 364,
   /// <summary>
   ///   North Down, United Kingdom (ND, GB)
   /// </summary>
   ND_GB = 365,
   /// <summary>
   ///   Ntheast Lincolnshire, United Kingdom (NE, GB)
   /// </summary>
   NE_GB = 366,
   /// <summary>
   ///   Northamptonshire, United Kingdom (NH, GB)
   /// </summary>
   NH_GB = 367,
   /// <summary>
   ///   Norfolk, United Kingdom (NK, GB)
   /// </summary>
   NK_GB = 368,
   /// <summary>
   ///   North Lincolnshire, United Kingdom (NL, GB)
   /// </summary>
   NL_GB = 369,
   /// <summary>
   ///   Newry And Mourne, United Kingdom (NM, GB)
   /// </summary>
   NM_GB = 370,
   /// <summary>
   ///   North Somerset, United Kingdom (NS, GB)
   /// </summary>
   NS_GB = 371,
   /// <summary>
   ///   Nottinghamshire, United Kingdom (NT, GB)
   /// </summary>
   NT_GB = 372,
   /// <summary>
   ///   Northumberland, United Kingdom (NU, GB)
   /// </summary>
   NU_GB = 373,
   /// <summary>
   ///   Omagh, United Kingdom (OM, GB)
   /// </summary>
   OM_GB = 374,
   /// <summary>
   ///   Orkney, United Kingdom (OR, GB)
   /// </summary>
   OR_GB = 375,
   /// <summary>
   ///   Oxfordshire, United Kingdom (OX, GB)
   /// </summary>
   OX_GB = 376,
   /// <summary>
   ///   Peterborough, United Kingdom (PB, GB)
   /// </summary>
   PB_GB = 377,
   /// <summary>
   ///   Poole, United Kingdom (PL, GB)
   /// </summary>
   PL_GB = 378,
   /// <summary>
   ///   Portsmouth, United Kingdom (PM, GB)
   /// </summary>
   PM_GB = 379,
   /// <summary>
   ///   Powys, United Kingdom (PO, GB)
   /// </summary>
   PO_GB = 380,
   /// <summary>
   ///   Plymouth, United Kingdom (PY, GB)
   /// </summary>
   PY_GB = 381,
   /// <summary>
   ///   Redcar And Cleveland, United Kingdom (RD, GB)
   /// </summary>
   RD_GB = 382,
   /// <summary>
   ///   Reading, United Kingdom (RE, GB)
   /// </summary>
   RE_GB = 383,
   /// <summary>
   ///   Rochester Up. Medway, United Kingdom (RM, GB)
   /// </summary>
   RM_GB = 384,
   /// <summary>
   ///   Rutland, United Kingdom (RU, GB)
   /// </summary>
   RU_GB = 385,
   /// <summary>
   ///   Strathclyde, United Kingdom (SC, GB)
   /// </summary>
   SC_GB = 386,
   /// <summary>
   ///   Southend, United Kingdom (SD, GB)
   /// </summary>
   SD_GB = 387,
   /// <summary>
   ///   East Sussex, United Kingdom (SE, GB)
   /// </summary>
   SE_GB = 388,
   /// <summary>
   ///   South Glamorgan, United Kingdom (SG, GB)
   /// </summary>
   SG_GB = 389,
   /// <summary>
   ///   Shropshire, United Kingdom (SH, GB)
   /// </summary>
   SH_GB = 390,
   /// <summary>
   ///   Suffolk, United Kingdom (SK, GB)
   /// </summary>
   SK_GB = 391,
   /// <summary>
   ///   Shetland, United Kingdom (SL, GB)
   /// </summary>
   SL_GB = 392,
   /// <summary>
   ///   Stockton-On-Tees, United Kingdom (SN, GB)
   /// </summary>
   SN_GB = 393,
   /// <summary>
   ///   Somerset, United Kingdom (SO, GB)
   /// </summary>
   SO_GB = 394,
   /// <summary>
   ///   Southampton, United Kingdom (SP, GB)
   /// </summary>
   SP_GB = 395,
   /// <summary>
   ///   Strabane, United Kingdom (SR, GB)
   /// </summary>
   SR_GB = 396,
   /// <summary>
   ///   Staffordshire, United Kingdom (ST, GB)
   /// </summary>
   ST_GB = 397,
   /// <summary>
   ///   Slough, United Kingdom (SU, GB)
   /// </summary>
   SU_GB = 398,
   /// <summary>
   ///   West Sussex, United Kingdom (SW, GB)
   /// </summary>
   SW_GB = 399,
   /// <summary>
   ///   Surrey, United Kingdom (SY, GB)
   /// </summary>
   SY_GB = 400,
   /// <summary>
   ///   Tayside, United Kingdom (TA, GB)
   /// </summary>
   TA_GB = 401,
   /// <summary>
   ///   Thamesdown, United Kingdom (TD, GB)
   /// </summary>
   TD_GB = 402,
   /// <summary>
   ///   Thurrock, United Kingdom (TH, GB)
   /// </summary>
   TH_GB = 403,
   /// <summary>
   ///   Torbay, United Kingdom (TO, GB)
   /// </summary>
   TO_GB = 404,
   /// <summary>
   ///   Tyne And Wear, United Kingdom (TW, GB)
   /// </summary>
   TW_GB = 405,
   /// <summary>
   ///   Warwickshire, United Kingdom (WA, GB)
   /// </summary>
   WA_GB = 406,
   /// <summary>
   ///   Windsor & Maidenhead, United Kingdom (WD, GB)
   /// </summary>
   WD_GB = 407,
   /// <summary>
   ///   West Glamorgan, United Kingdom (WG, GB)
   /// </summary>
   WG_GB = 408,
   /// <summary>
   ///   Wiltshire, United Kingdom (WI, GB)
   /// </summary>
   WI_GB = 409,
   /// <summary>
   ///   Western Isles, United Kingdom (WL, GB)
   /// </summary>
   WL_GB = 410,
   /// <summary>
   ///   West Midlands, United Kingdom (WM, GB)
   /// </summary>
   WM_GB = 411,
   /// <summary>
   ///   Wokingham, United Kingdom (WO, GB)
   /// </summary>
   WO_GB = 412,
   /// <summary>
   ///   Wrekin, United Kingdom (WR, GB)
   /// </summary>
   WR_GB = 413,
   /// <summary>
   ///   Warrington, United Kingdom (WT, GB)
   /// </summary>
   WT_GB = 414,
   /// <summary>
   ///   York, United Kingdom (YK, GB)
   /// </summary>
   YK_GB = 415,
   /// <summary>
   ///   North Yorkshire, United Kingdom (YN, GB)
   /// </summary>
   YN_GB = 416,
   /// <summary>
   ///   South Yorkshire, United Kingdom (YS, GB)
   /// </summary>
   YS_GB = 417,
   /// <summary>
   ///   West Yorkshire, United Kingdom (YW, GB)
   /// </summary>
   YW_GB = 418,
   /// <summary>
   ///   Hong Kong Island, Hong Kong (HK, HK)
   /// </summary>
   HK_HK = 419,
   /// <summary>
   ///   Kowloon, Hong Kong (KLN, HK)
   /// </summary>
   KLN_HK = 420,
   /// <summary>
   ///   New Territories, Hong Kong (NT, HK)
   /// </summary>
   NT_HK = 421,
   /// <summary>
   ///   Cork, Ireland (CK, IE)
   /// </summary>
   CK_IE = 422,
   /// <summary>
   ///   Clare, Ireland (CL, IE)
   /// </summary>
   CL_IE = 423,
   /// <summary>
   ///   Carlow, Ireland (CW, IE)
   /// </summary>
   CW_IE = 424,
   /// <summary>
   ///   Dublin, Ireland (DB, IE)
   /// </summary>
   DB_IE = 425,
   /// <summary>
   ///   Donegal, Ireland (DG, IE)
   /// </summary>
   DG_IE = 426,
   /// <summary>
   ///   Galway, Ireland (GW, IE)
   /// </summary>
   GW_IE = 427,
   /// <summary>
   ///   Kildare, Ireland (KD, IE)
   /// </summary>
   KD_IE = 428,
   /// <summary>
   ///   Kilkenny, Ireland (KK, IE)
   /// </summary>
   KK_IE = 429,
   /// <summary>
   ///   Cavan, Ireland (KV, IE)
   /// </summary>
   KV_IE = 430,
   /// <summary>
   ///   Kerry, Ireland (KY, IE)
   /// </summary>
   KY_IE = 431,
   /// <summary>
   ///   Longford, Ireland (LF, IE)
   /// </summary>
   LF_IE = 432,
   /// <summary>
   ///   Limerick, Ireland (LI, IE)
   /// </summary>
   LI_IE = 433,
   /// <summary>
   ///   Leitrim, Ireland (LM, IE)
   /// </summary>
   LM_IE = 434,
   /// <summary>
   ///   Laois, Ireland (LS, IE)
   /// </summary>
   LS_IE = 435,
   /// <summary>
   ///   Louth, Ireland (LT, IE)
   /// </summary>
   LT_IE = 436,
   /// <summary>
   ///   Monaghan, Ireland (MH, IE)
   /// </summary>
   MH_IE = 437,
   /// <summary>
   ///   Meath, Ireland (MT, IE)
   /// </summary>
   MT_IE = 438,
   /// <summary>
   ///   Mayo, Ireland (MY, IE)
   /// </summary>
   MY_IE = 439,
   /// <summary>
   ///   Offaly, Ireland (OS, IE)
   /// </summary>
   OS_IE = 440,
   /// <summary>
   ///   Rosscommon, Ireland (RC, IE)
   /// </summary>
   RC_IE = 441,
   /// <summary>
   ///   Sligo, Ireland (SG, IE)
   /// </summary>
   SG_IE = 442,
   /// <summary>
   ///   Tipperary, Ireland (TP, IE)
   /// </summary>
   TP_IE = 443,
   /// <summary>
   ///   Waterford, Ireland (WF, IE)
   /// </summary>
   WF_IE = 444,
   /// <summary>
   ///   Wicklow, Ireland (WK, IE)
   /// </summary>
   WK_IE = 445,
   /// <summary>
   ///   Westmeath, Ireland (WM, IE)
   /// </summary>
   WM_IE = 446,
   /// <summary>
   ///   Wexford, Ireland (WX, IE)
   /// </summary>
   WX_IE = 447,
   /// <summary>
   ///   Agriento, Italy (AG, IT)
   /// </summary>
   AG_IT = 448,
   /// <summary>
   ///   Alessandria, Italy (AL, IT)
   /// </summary>
   AL_IT = 449,
   /// <summary>
   ///   Ancona, Italy (AN, IT)
   /// </summary>
   AN_IT = 450,
   /// <summary>
   ///   Aosta, Italy (AO, IT)
   /// </summary>
   AO_IT = 451,
   /// <summary>
   ///   Ascoli Piceno, Italy (AP, IT)
   /// </summary>
   AP_IT = 452,
   /// <summary>
   ///   L'aquila, Italy (AQ, IT)
   /// </summary>
   AQ_IT = 453,
   /// <summary>
   ///   Arezzo, Italy (AR, IT)
   /// </summary>
   AR_IT = 454,
   /// <summary>
   ///   Asti, Italy (AT, IT)
   /// </summary>
   AT_IT = 455,
   /// <summary>
   ///   Avellino, Italy (AV, IT)
   /// </summary>
   AV_IT = 456,
   /// <summary>
   ///   Bari, Italy (BA, IT)
   /// </summary>
   BA_IT = 457,
   /// <summary>
   ///   Bergamo, Italy (BG, IT)
   /// </summary>
   BG_IT = 458,
   /// <summary>
   ///   Biella, Italy (BI, IT)
   /// </summary>
   BI_IT = 459,
   /// <summary>
   ///   Belluno, Italy (BL, IT)
   /// </summary>
   BL_IT = 460,
   /// <summary>
   ///   Benevento, Italy (BN, IT)
   /// </summary>
   BN_IT = 461,
   /// <summary>
   ///   Bologna, Italy (BO, IT)
   /// </summary>
   BO_IT = 462,
   /// <summary>
   ///   Brindisi, Italy (BR, IT)
   /// </summary>
   BR_IT = 463,
   /// <summary>
   ///   Brescia, Italy (BS, IT)
   /// </summary>
   BS_IT = 464,
   /// <summary>
   ///   Bolzano, Italy (BZ, IT)
   /// </summary>
   BZ_IT = 465,
   /// <summary>
   ///   Cagliari, Italy (CA, IT)
   /// </summary>
   CA_IT = 466,
   /// <summary>
   ///   Campobasso, Italy (CB, IT)
   /// </summary>
   CB_IT = 467,
   /// <summary>
   ///   Caserta, Italy (CE, IT)
   /// </summary>
   CE_IT = 468,
   /// <summary>
   ///   Chieti, Italy (CH, IT)
   /// </summary>
   CH_IT = 469,
   /// <summary>
   ///   Caltanisetta, Italy (CL, IT)
   /// </summary>
   CL_IT = 470,
   /// <summary>
   ///   Cuneo, Italy (CN, IT)
   /// </summary>
   CN_IT = 471,
   /// <summary>
   ///   Como, Italy (CO, IT)
   /// </summary>
   CO_IT = 472,
   /// <summary>
   ///   Cremona, Italy (CR, IT)
   /// </summary>
   CR_IT = 473,
   /// <summary>
   ///   Cosenza, Italy (CS, IT)
   /// </summary>
   CS_IT = 474,
   /// <summary>
   ///   Catania, Italy (CT, IT)
   /// </summary>
   CT_IT = 475,
   /// <summary>
   ///   Catanzaro, Italy (CZ, IT)
   /// </summary>
   CZ_IT = 476,
   /// <summary>
   ///   Enna, Italy (EN, IT)
   /// </summary>
   EN_IT = 477,
   /// <summary>
   ///   Ferrara, Italy (FE, IT)
   /// </summary>
   FE_IT = 478,
   /// <summary>
   ///   Foggia, Italy (FG, IT)
   /// </summary>
   FG_IT = 479,
   /// <summary>
   ///   Firenze, Italy (FI, IT)
   /// </summary>
   FI_IT = 480,
   /// <summary>
   ///   Forlì, Italy (FO, IT)
   /// </summary>
   FO_IT = 481,
   /// <summary>
   ///   Frosinone, Italy (FR, IT)
   /// </summary>
   FR_IT = 482,
   /// <summary>
   ///   Genova, Italy (GE, IT)
   /// </summary>
   GE_IT = 483,
   /// <summary>
   ///   Gorizia, Italy (GO, IT)
   /// </summary>
   GO_IT = 484,
   /// <summary>
   ///   Grosseto, Italy (GR, IT)
   /// </summary>
   GR_IT = 485,
   /// <summary>
   ///   Imperia, Italy (IM, IT)
   /// </summary>
   IM_IT = 486,
   /// <summary>
   ///   Isernia, Italy (IS, IT)
   /// </summary>
   IS_IT = 487,
   /// <summary>
   ///   Crotone, Italy (KR, IT)
   /// </summary>
   KR_IT = 488,
   /// <summary>
   ///   Lecco, Italy (LC, IT)
   /// </summary>
   LC_IT = 489,
   /// <summary>
   ///   Lecce, Italy (LE, IT)
   /// </summary>
   LE_IT = 490,
   /// <summary>
   ///   Livorno, Italy (LI, IT)
   /// </summary>
   LI_IT = 491,
   /// <summary>
   ///   Lodi, Italy (LO, IT)
   /// </summary>
   LO_IT = 492,
   /// <summary>
   ///   Latina, Italy (LT, IT)
   /// </summary>
   LT_IT = 493,
   /// <summary>
   ///   Lucca, Italy (LU, IT)
   /// </summary>
   LU_IT = 494,
   /// <summary>
   ///   Macerata, Italy (MC, IT)
   /// </summary>
   MC_IT = 495,
   /// <summary>
   ///   Messina, Italy (ME, IT)
   /// </summary>
   ME_IT = 496,
   /// <summary>
   ///   Milan, Italy (MI, IT)
   /// </summary>
   MI_IT = 497,
   /// <summary>
   ///   Mantova, Italy (MN, IT)
   /// </summary>
   MN_IT = 498,
   /// <summary>
   ///   Modena, Italy (MO, IT)
   /// </summary>
   MO_IT = 499,
   /// <summary>
   ///   Massa Carrara, Italy (MS, IT)
   /// </summary>
   MS_IT = 500,
   /// <summary>
   ///   Matera, Italy (MT, IT)
   /// </summary>
   MT_IT = 501,
   /// <summary>
   ///   Napoli, Italy (NA, IT)
   /// </summary>
   NA_IT = 502,
   /// <summary>
   ///   Novara, Italy (NO, IT)
   /// </summary>
   NO_IT = 503,
   /// <summary>
   ///   Nuoro, Italy (NU, IT)
   /// </summary>
   NU_IT = 504,
   /// <summary>
   ///   Oristano, Italy (OR, IT)
   /// </summary>
   OR_IT = 505,
   /// <summary>
   ///   Palermo, Italy (PA, IT)
   /// </summary>
   PA_IT = 506,
   /// <summary>
   ///   Piacenza, Italy (PC, IT)
   /// </summary>
   PC_IT = 507,
   /// <summary>
   ///   Padova, Italy (PD, IT)
   /// </summary>
   PD_IT = 508,
   /// <summary>
   ///   Pescara, Italy (PE, IT)
   /// </summary>
   PE_IT = 509,
   /// <summary>
   ///   Perugia, Italy (PG, IT)
   /// </summary>
   PG_IT = 510,
   /// <summary>
   ///   Pisa, Italy (PI, IT)
   /// </summary>
   PI_IT = 511,
   /// <summary>
   ///   Pordenone, Italy (PN, IT)
   /// </summary>
   PN_IT = 512,
   /// <summary>
   ///   Prato, Italy (PO, IT)
   /// </summary>
   PO_IT = 513,
   /// <summary>
   ///   Parma, Italy (PR, IT)
   /// </summary>
   PR_IT = 514,
   /// <summary>
   ///   Pesaro, Italy (PS, IT)
   /// </summary>
   PS_IT = 515,
   /// <summary>
   ///   Pistoia, Italy (PT, IT)
   /// </summary>
   PT_IT = 516,
   /// <summary>
   ///   Pavia, Italy (PV, IT)
   /// </summary>
   PV_IT = 517,
   /// <summary>
   ///   Potenza, Italy (PZ, IT)
   /// </summary>
   PZ_IT = 518,
   /// <summary>
   ///   Ravenna, Italy (RA, IT)
   /// </summary>
   RA_IT = 519,
   /// <summary>
   ///   Reggio Calabria, Italy (RC, IT)
   /// </summary>
   RC_IT = 520,
   /// <summary>
   ///   Reggio Emilia, Italy (RE, IT)
   /// </summary>
   RE_IT = 521,
   /// <summary>
   ///   Ragusa, Italy (RG, IT)
   /// </summary>
   RG_IT = 522,
   /// <summary>
   ///   Rieti, Italy (RI, IT)
   /// </summary>
   RI_IT = 523,
   /// <summary>
   ///   Rome, Italy (RM, IT)
   /// </summary>
   RM_IT = 524,
   /// <summary>
   ///   Rimini, Italy (RN, IT)
   /// </summary>
   RN_IT = 525,
   /// <summary>
   ///   Rovigo, Italy (RO, IT)
   /// </summary>
   RO_IT = 526,
   /// <summary>
   ///   Rovigo, Italy (RV, IT)
   /// </summary>
   RV_IT = 527,
   /// <summary>
   ///   Salerno, Italy (SA, IT)
   /// </summary>
   SA_IT = 528,
   /// <summary>
   ///   Siena, Italy (SI, IT)
   /// </summary>
   SI_IT = 529,
   /// <summary>
   ///   Sondrio, Italy (SO, IT)
   /// </summary>
   SO_IT = 530,
   /// <summary>
   ///   La Spezia, Italy (SP, IT)
   /// </summary>
   SP_IT = 531,
   /// <summary>
   ///   Siracusa, Italy (SR, IT)
   /// </summary>
   SR_IT = 532,
   /// <summary>
   ///   Sassari, Italy (SS, IT)
   /// </summary>
   SS_IT = 533,
   /// <summary>
   ///   Savona, Italy (SV, IT)
   /// </summary>
   SV_IT = 534,
   /// <summary>
   ///   Taranto, Italy (TA, IT)
   /// </summary>
   TA_IT = 535,
   /// <summary>
   ///   Teramo, Italy (TE, IT)
   /// </summary>
   TE_IT = 536,
   /// <summary>
   ///   Trento, Italy (TN, IT)
   /// </summary>
   TN_IT = 537,
   /// <summary>
   ///   Turin, Italy (TO, IT)
   /// </summary>
   TO_IT = 538,
   /// <summary>
   ///   Trapani, Italy (TP, IT)
   /// </summary>
   TP_IT = 539,
   /// <summary>
   ///   Terni, Italy (TR, IT)
   /// </summary>
   TR_IT = 540,
   /// <summary>
   ///   Trieste, Italy (TS, IT)
   /// </summary>
   TS_IT = 541,
   /// <summary>
   ///   Treviso, Italy (TV, IT)
   /// </summary>
   TV_IT = 542,
   /// <summary>
   ///   Udine, Italy (UD, IT)
   /// </summary>
   UD_IT = 543,
   /// <summary>
   ///   Varese, Italy (VA, IT)
   /// </summary>
   VA_IT = 544,
   /// <summary>
   ///   Vercelli, Italy (VC, IT)
   /// </summary>
   VC_IT = 545,
   /// <summary>
   ///   Venice, Italy (VE, IT)
   /// </summary>
   VE_IT = 546,
   /// <summary>
   ///   Vicenza, Italy (VI, IT)
   /// </summary>
   VI_IT = 547,
   /// <summary>
   ///   Verona, Italy (VR, IT)
   /// </summary>
   VR_IT = 548,
   /// <summary>
   ///   Viterbo, Italy (VT, IT)
   /// </summary>
   VT_IT = 549,
   /// <summary>
   ///   Vibo Valentia, Italy (VV, IT)
   /// </summary>
   VV_IT = 550,
   /// <summary>
   ///   Aguascalientes, Mexico (AGS, MX)
   /// </summary>
   AGS_MX = 598,
   /// <summary>
   ///   Baja California N, Mexico (BCN, MX)
   /// </summary>
   BCN_MX = 599,
   /// <summary>
   ///   Baja California S, Mexico (BCS, MX)
   /// </summary>
   BCS_MX = 600,
   /// <summary>
   ///   Chihuahua, Mexico (CHI, MX)
   /// </summary>
   CHI_MX = 601,
   /// <summary>
   ///   Chiapas, Mexico (CHS, MX)
   /// </summary>
   CHS_MX = 602,
   /// <summary>
   ///   Campeche, Mexico (CMP, MX)
   /// </summary>
   CMP_MX = 603,
   /// <summary>
   ///   Coahuila, Mexico (COA, MX)
   /// </summary>
   COA_MX = 604,
   /// <summary>
   ///   Colima, Mexico (COL, MX)
   /// </summary>
   COL_MX = 605,
   /// <summary>
   ///   Distrito Federal, Mexico (DF, MX)
   /// </summary>
   DF_MX = 606,
   /// <summary>
   ///   Durango, Mexico (DGO, MX)
   /// </summary>
   DGO_MX = 607,
   /// <summary>
   ///   Guerrero, Mexico (GRO, MX)
   /// </summary>
   GRO_MX = 608,
   /// <summary>
   ///   Guanajuato, Mexico (GTO, MX)
   /// </summary>
   GTO_MX = 609,
   /// <summary>
   ///   Hidalgo, Mexico (HGO, MX)
   /// </summary>
   HGO_MX = 610,
   /// <summary>
   ///   Jalisco, Mexico (JAL, MX)
   /// </summary>
   JAL_MX = 611,
   /// <summary>
   ///   Michoacán, Mexico (MCH, MX)
   /// </summary>
   MCH_MX = 612,
   /// <summary>
   ///   Estado De México, Mexico (MEX, MX)
   /// </summary>
   MEX_MX = 613,
   /// <summary>
   ///   Morelos, Mexico (MOR, MX)
   /// </summary>
   MOR_MX = 614,
   /// <summary>
   ///   Nuevo Léon, Mexico (NL, MX)
   /// </summary>
   NL_MX = 615,
   /// <summary>
   ///   Oaxaca, Mexico (OAX, MX)
   /// </summary>
   OAX_MX = 616,
   /// <summary>
   ///   Puebla, Mexico (PUE, MX)
   /// </summary>
   PUE_MX = 617,
   /// <summary>
   ///   Quintana Roo, Mexico (QR, MX)
   /// </summary>
   QR_MX = 618,
   /// <summary>
   ///   Querétaro, Mexico (QRO, MX)
   /// </summary>
   QRO_MX = 619,
   /// <summary>
   ///   Sinaloa, Mexico (SIN, MX)
   /// </summary>
   SIN_MX = 620,
   /// <summary>
   ///   San Luis Potosí, Mexico (SLP, MX)
   /// </summary>
   SLP_MX = 621,
   /// <summary>
   ///   Sonora, Mexico (SON, MX)
   /// </summary>
   SON_MX = 622,
   /// <summary>
   ///   Tabasco, Mexico (TAB, MX)
   /// </summary>
   TAB_MX = 623,
   /// <summary>
   ///   Tlaxcala, Mexico (TLX, MX)
   /// </summary>
   TLX_MX = 624,
   /// <summary>
   ///   Tamaulipas, Mexico (TMS, MX)
   /// </summary>
   TMS_MX = 625,
   /// <summary>
   ///   Veracruz, Mexico (VER, MX)
   /// </summary>
   VER_MX = 626,
   /// <summary>
   ///   Yucatán, Mexico (YUC, MX)
   /// </summary>
   YUC_MX = 627,
   /// <summary>
   ///   Zacatecas, Mexico (ZAC, MX)
   /// </summary>
   ZAC_MX = 628,
   /// <summary>
   ///   Johor, Malaysia (JOH, MY)
   /// </summary>
   JOH_MY = 629,
   /// <summary>
   ///   Kedah, Malaysia (KED, MY)
   /// </summary>
   KED_MY = 630,
   /// <summary>
   ///   Kelantan, Malaysia (KEL, MY)
   /// </summary>
   KEL_MY = 631,
   /// <summary>
   ///   Kuala Lumpur, Malaysia (KUL, MY)
   /// </summary>
   KUL_MY = 632,
   /// <summary>
   ///   Labuan, Malaysia (LAB, MY)
   /// </summary>
   LAB_MY = 633,
   /// <summary>
   ///   Melaka, Malaysia (MEL, MY)
   /// </summary>
   MEL_MY = 634,
   /// <summary>
   ///   Pahang, Malaysia (PAH, MY)
   /// </summary>
   PAH_MY = 635,
   /// <summary>
   ///   Perlis, Malaysia (PEL, MY)
   /// </summary>
   PEL_MY = 636,
   /// <summary>
   ///   Perak, Malaysia (PER, MY)
   /// </summary>
   PER_MY = 637,
   /// <summary>
   ///   Pulau Pinang, Malaysia (PIN, MY)
   /// </summary>
   PIN_MY = 638,
   /// <summary>
   ///   Sabah, Malaysia (SAB, MY)
   /// </summary>
   SAB_MY = 639,
   /// <summary>
   ///   Sarawak, Malaysia (SAR, MY)
   /// </summary>
   SAR_MY = 640,
   /// <summary>
   ///   Selangor, Malaysia (SEL, MY)
   /// </summary>
   SEL_MY = 641,
   /// <summary>
   ///   Negeri Sembilan, Malaysia (SER, MY)
   /// </summary>
   SER_MY = 642,
   /// <summary>
   ///   Trengganu, Malaysia (TRE, MY)
   /// </summary>
   TRE_MY = 643,
   /// <summary>
   ///   North Island, New Zealand (NI, NZ)
   /// </summary>
   NI_NZ = 664,
   /// <summary>
   ///   South Island, New Zealand (SI, NZ)
   /// </summary>
   SI_NZ = 665,
   /// <summary>
   ///   Sg-East, Singapore (SE, SG)
   /// </summary>
   SE_SG = 720,
   /// <summary>
   ///   Sg-North, Singapore (SN, SG)
   /// </summary>
   SN_SG = 721,
   /// <summary>
   ///   Sg-South, Singapore (SS, SG)
   /// </summary>
   SS_SG = 722,
   /// <summary>
   ///   Sg-West, Singapore (SW, SG)
   /// </summary>
   SW_SG = 723,
   /// <summary>
   ///   Central, Thailand (C, TH)
   /// </summary>
   C_TH = 724,
   /// <summary>
   ///   East, Thailand (E, TH)
   /// </summary>
   E_TH = 725,
   /// <summary>
   ///   North, Thailand (N, TH)
   /// </summary>
   N_TH = 726,
   /// <summary>
   ///   South, Thailand (S, TH)
   /// </summary>
   S_TH = 727,
   /// <summary>
   ///   West, Thailand (W, TH)
   /// </summary>
   W_TH = 728,
   /// <summary>
   ///   Kaoshung City, Taiwan (KSH, TW)
   /// </summary>
   KSH_TW = 729,
   /// <summary>
   ///   Taipei City, Taiwan (TPE, TW)
   /// </summary>
   TPE_TW = 730,
   /// <summary>
   ///   Taiwan Prov., Taiwan (TWN, TW)
   /// </summary>
   TWN_TW = 731,
   /// <summary>
   ///   Apo/fpo Aa, United States (AA, US)
   /// </summary>
   AA_US = 732,
   /// <summary>
   ///   Apo/fpo Ae, United States (AE, US)
   /// </summary>
   AE_US = 733,
   /// <summary>
   ///   Alaska, United States (AK, US)
   /// </summary>
   AK_US = 734,
   /// <summary>
   ///   Alabama, United States (AL, US)
   /// </summary>
   AL_US = 735,
   /// <summary>
   ///   Apo/fpo Ap, United States (AP, US)
   /// </summary>
   AP_US = 736,
   /// <summary>
   ///   Arkansas, United States (AR, US)
   /// </summary>
   AR_US = 737,
   /// <summary>
   ///   American Samoa, United States (AS, US)
   /// </summary>
   AS_US = 738,
   /// <summary>
   ///   Arizona, United States (AZ, US)
   /// </summary>
   AZ_US = 739,
   /// <summary>
   ///   California, United States (CA, US)
   /// </summary>
   CA_US = 740,
   /// <summary>
   ///   Colorado, United States (CO, US)
   /// </summary>
   CO_US = 741,
   /// <summary>
   ///   Connecticut, United States (CT, US)
   /// </summary>
   CT_US = 742,
   /// <summary>
   ///   District Of Columbia, United States (DC, US)
   /// </summary>
   DC_US = 743,
   /// <summary>
   ///   Delaware, United States (DE, US)
   /// </summary>
   DE_US = 744,
   /// <summary>
   ///   Florida, United States (FL, US)
   /// </summary>
   FL_US = 745,
   /// <summary>
   ///   Georgia, United States (GA, US)
   /// </summary>
   GA_US = 746,
   /// <summary>
   ///   Guam, United States (GU, US)
   /// </summary>
   GU_US = 747,
   /// <summary>
   ///   Hawaii, United States (HI, US)
   /// </summary>
   HI_US = 748,
   /// <summary>
   ///   Iowa, United States (IA, US)
   /// </summary>
   IA_US = 749,
   /// <summary>
   ///   Idaho, United States (ID, US)
   /// </summary>
   ID_US = 750,
   /// <summary>
   ///   Illinois, United States (IL, US)
   /// </summary>
   IL_US = 751,
   /// <summary>
   ///   Indiana, United States (IN, US)
   /// </summary>
   IN_US = 752,
   /// <summary>
   ///   Kansas, United States (KS, US)
   /// </summary>
   KS_US = 753,
   /// <summary>
   ///   Kentucky, United States (KY, US)
   /// </summary>
   KY_US = 754,
   /// <summary>
   ///   Louisiana, United States (LA, US)
   /// </summary>
   LA_US = 755,
   /// <summary>
   ///   Massachusetts, United States (MA, US)
   /// </summary>
   MA_US = 756,
   /// <summary>
   ///   Maryland, United States (MD, US)
   /// </summary>
   MD_US = 757,
   /// <summary>
   ///   Maine, United States (ME, US)
   /// </summary>
   ME_US = 758,
   /// <summary>
   ///   Michigan, United States (MI, US)
   /// </summary>
   MI_US = 759,
   /// <summary>
   ///   Minnesota, United States (MN, US)
   /// </summary>
   MN_US = 760,
   /// <summary>
   ///   Missouri, United States (MO, US)
   /// </summary>
   MO_US = 761,
   /// <summary>
   ///   Northern Mariana Isl, United States (MP, US)
   /// </summary>
   MP_US = 762,
   /// <summary>
   ///   Mississippi, United States (MS, US)
   /// </summary>
   MS_US = 763,
   /// <summary>
   ///   Montana, United States (MT, US)
   /// </summary>
   MT_US = 764,
   /// <summary>
   ///   North Carolina, United States (NC, US)
   /// </summary>
   NC_US = 765,
   /// <summary>
   ///   North Dakota, United States (ND, US)
   /// </summary>
   ND_US = 766,
   /// <summary>
   ///   Nebraska, United States (NE, US)
   /// </summary>
   NE_US = 767,
   /// <summary>
   ///   New Hampshire, United States (NH, US)
   /// </summary>
   NH_US = 768,
   /// <summary>
   ///   New Jersey, United States (NJ, US)
   /// </summary>
   NJ_US = 769,
   /// <summary>
   ///   New Mexico, United States (NM, US)
   /// </summary>
   NM_US = 770,
   /// <summary>
   ///   Nevada, United States (NV, US)
   /// </summary>
   NV_US = 771,
   /// <summary>
   ///   New York, United States (NY, US)
   /// </summary>
   NY_US = 772,
   /// <summary>
   ///   Ohio, United States (OH, US)
   /// </summary>
   OH_US = 773,
   /// <summary>
   ///   Oklahoma, United States (OK, US)
   /// </summary>
   OK_US = 774,
   /// <summary>
   ///   Oregon, United States (OR, US)
   /// </summary>
   OR_US = 775,
   /// <summary>
   ///   Pennsylvania, United States (PA, US)
   /// </summary>
   PA_US = 776,
   /// <summary>
   ///   Puerto Rico, United States (PR, US)
   /// </summary>
   PR_US = 777,
   /// <summary>
   ///   Rhode Island, United States (RI, US)
   /// </summary>
   RI_US = 778,
   /// <summary>
   ///   South Carolina, United States (SC, US)
   /// </summary>
   SC_US = 779,
   /// <summary>
   ///   South Dakota, United States (SD, US)
   /// </summary>
   SD_US = 780,
   /// <summary>
   ///   Tennessee, United States (TN, US)
   /// </summary>
   TN_US = 781,
   /// <summary>
   ///   Texas, United States (TX, US)
   /// </summary>
   TX_US = 782,
   /// <summary>
   ///   Utah, United States (UT, US)
   /// </summary>
   UT_US = 783,
   /// <summary>
   ///   Virginia, United States (VA, US)
   /// </summary>
   VA_US = 784,
   /// <summary>
   ///   Virgin Islands, United States (VI, US)
   /// </summary>
   VI_US = 785,
   /// <summary>
   ///   Vermont, United States (VT, US)
   /// </summary>
   VT_US = 786,
   /// <summary>
   ///   Washington, United States (WA, US)
   /// </summary>
   WA_US = 787,
   /// <summary>
   ///   Wisconsin, United States (WI, US)
   /// </summary>
   WI_US = 788,
   /// <summary>
   ///   West Virginia, United States (WV, US)
   /// </summary>
   WV_US = 789,
   /// <summary>
   ///   Wyoming, United States (WY, US)
   /// </summary>
   WY_US = 790
}

export const StateProvinces: StateProvince[] = [
   {
      code: StateProvince_.Unknown,
      literal: 'Unknown',
      description: '',
      shortDescription: '',
      listPriority: 0,

      countryCode: 0,

      standardCode: '',

      name: '',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.B_AT,
      literal: 'B_AT',
      description: 'Burgenland, Austria',
      shortDescription: 'B, AT',
      listPriority: 0,

      countryCode: 13,

      standardCode: 'B',

      name: 'Burgenland',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.K_AT,
      literal: 'K_AT',
      description: 'Corinthia, Austria',
      shortDescription: 'K, AT',
      listPriority: 0,

      countryCode: 13,

      standardCode: 'K',

      name: 'Corinthia',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NO_AT,
      literal: 'NO_AT',
      description: 'Lower Austria, Austria',
      shortDescription: 'NÖ, AT',
      listPriority: 0,

      countryCode: 13,

      standardCode: 'NÖ',

      name: 'Lower Austria',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.OO_AT,
      literal: 'OO_AT',
      description: 'Upper Austria, Austria',
      shortDescription: 'OÖ, AT',
      listPriority: 0,

      countryCode: 13,

      standardCode: 'OÖ',

      name: 'Upper Austria',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.S_AT,
      literal: 'S_AT',
      description: 'Salzburg, Austria',
      shortDescription: 'S, AT',
      listPriority: 0,

      countryCode: 13,

      standardCode: 'S',

      name: 'Salzburg',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ST_AT,
      literal: 'ST_AT',
      description: 'Styria, Austria',
      shortDescription: 'ST, AT',
      listPriority: 0,

      countryCode: 13,

      standardCode: 'ST',

      name: 'Styria',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.T_AT,
      literal: 'T_AT',
      description: 'Tyrol, Austria',
      shortDescription: 'T, AT',
      listPriority: 0,

      countryCode: 13,

      standardCode: 'T',

      name: 'Tyrol',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.V_AT,
      literal: 'V_AT',
      description: 'Vorarlberg, Austria',
      shortDescription: 'V, AT',
      listPriority: 0,

      countryCode: 13,

      standardCode: 'V',

      name: 'Vorarlberg',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.W_AT,
      literal: 'W_AT',
      description: 'Vienna, Austria',
      shortDescription: 'W, AT',
      listPriority: 0,

      countryCode: 13,

      standardCode: 'W',

      name: 'Vienna',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ACT_AU,
      literal: 'ACT_AU',
      description: 'Aust Capital Terr, Australia',
      shortDescription: 'ACT, AU',
      listPriority: 0,

      countryCode: 14,

      standardCode: 'ACT',

      name: 'Aust Capital Terr',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NSW_AU,
      literal: 'NSW_AU',
      description: 'New South Wales, Australia',
      shortDescription: 'NSW, AU',
      listPriority: 0,

      countryCode: 14,

      standardCode: 'NSW',

      name: 'New South Wales',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NT_AU,
      literal: 'NT_AU',
      description: 'Northern Territory, Australia',
      shortDescription: 'NT, AU',
      listPriority: 0,

      countryCode: 14,

      standardCode: 'NT',

      name: 'Northern Territory',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.QLD_AU,
      literal: 'QLD_AU',
      description: 'Queensland, Australia',
      shortDescription: 'QLD, AU',
      listPriority: 0,

      countryCode: 14,

      standardCode: 'QLD',

      name: 'Queensland',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SA_AU,
      literal: 'SA_AU',
      description: 'South Australia, Australia',
      shortDescription: 'SA, AU',
      listPriority: 0,

      countryCode: 14,

      standardCode: 'SA',

      name: 'South Australia',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TAS_AU,
      literal: 'TAS_AU',
      description: 'Tasmania, Australia',
      shortDescription: 'TAS, AU',
      listPriority: 0,

      countryCode: 14,

      standardCode: 'TAS',

      name: 'Tasmania',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.VIC_AU,
      literal: 'VIC_AU',
      description: 'Victoria, Australia',
      shortDescription: 'VIC, AU',
      listPriority: 0,

      countryCode: 14,

      standardCode: 'VIC',

      name: 'Victoria',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WA_AU,
      literal: 'WA_AU',
      description: 'Western Australia, Australia',
      shortDescription: 'WA, AU',
      listPriority: 0,

      countryCode: 14,

      standardCode: 'WA',

      name: 'Western Australia',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AB_CA,
      literal: 'AB_CA',
      description: 'Alberta, Canada',
      shortDescription: 'AB, CA',
      listPriority: 0,

      countryCode: 36,

      standardCode: 'AB',

      name: 'Alberta',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BC_CA,
      literal: 'BC_CA',
      description: 'British Columbia, Canada',
      shortDescription: 'BC, CA',
      listPriority: 0,

      countryCode: 36,

      standardCode: 'BC',

      name: 'British Columbia',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MB_CA,
      literal: 'MB_CA',
      description: 'Manitoba, Canada',
      shortDescription: 'MB, CA',
      listPriority: 0,

      countryCode: 36,

      standardCode: 'MB',

      name: 'Manitoba',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NB_CA,
      literal: 'NB_CA',
      description: 'New Brunswick, Canada',
      shortDescription: 'NB, CA',
      listPriority: 0,

      countryCode: 36,

      standardCode: 'NB',

      name: 'New Brunswick',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NL_CA,
      literal: 'NL_CA',
      description: 'Newfoundland, Canada',
      shortDescription: 'NL, CA',
      listPriority: 0,

      countryCode: 36,

      standardCode: 'NL',

      name: 'Newfoundland',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NS_CA,
      literal: 'NS_CA',
      description: 'Nova Scotia, Canada',
      shortDescription: 'NS, CA',
      listPriority: 0,

      countryCode: 36,

      standardCode: 'NS',

      name: 'Nova Scotia',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NT_CA,
      literal: 'NT_CA',
      description: 'Northwest Territory, Canada',
      shortDescription: 'NT, CA',
      listPriority: 0,

      countryCode: 36,

      standardCode: 'NT',

      name: 'Northwest Territory',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NU_CA,
      literal: 'NU_CA',
      description: 'Nunavut, Canada',
      shortDescription: 'NU, CA',
      listPriority: 0,

      countryCode: 36,

      standardCode: 'NU',

      name: 'Nunavut',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ON_CA,
      literal: 'ON_CA',
      description: 'Ontario, Canada',
      shortDescription: 'ON, CA',
      listPriority: 0,

      countryCode: 36,

      standardCode: 'ON',

      name: 'Ontario',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PE_CA,
      literal: 'PE_CA',
      description: 'Prince Edward Island, Canada',
      shortDescription: 'PE, CA',
      listPriority: 0,

      countryCode: 36,

      standardCode: 'PE',

      name: 'Prince Edward Island',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.QC_CA,
      literal: 'QC_CA',
      description: 'Quebec, Canada',
      shortDescription: 'QC, CA',
      listPriority: 0,

      countryCode: 36,

      standardCode: 'QC',

      name: 'Quebec',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SK_CA,
      literal: 'SK_CA',
      description: 'Saskatchewan, Canada',
      shortDescription: 'SK, CA',
      listPriority: 0,

      countryCode: 36,

      standardCode: 'SK',

      name: 'Saskatchewan',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.YT_CA,
      literal: 'YT_CA',
      description: 'Yukon, Canada',
      shortDescription: 'YT, CA',
      listPriority: 0,

      countryCode: 36,

      standardCode: 'YT',

      name: 'Yukon',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ZZ_CA,
      literal: 'ZZ_CA',
      description: 'Outside Province/can, Canada',
      shortDescription: 'ZZ, CA',
      listPriority: 0,

      countryCode: 36,

      standardCode: 'ZZ',

      name: 'Outside Province/can',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AG_CH,
      literal: 'AG_CH',
      description: 'Aargau, Switzerland',
      shortDescription: 'AG, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'AG',

      name: 'Aargau',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AI_CH,
      literal: 'AI_CH',
      description: 'Appenzell Innerrh, Switzerland',
      shortDescription: 'AI, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'AI',

      name: 'Appenzell Innerrh',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AR_CH,
      literal: 'AR_CH',
      description: 'Appenzell Ausserrh., Switzerland',
      shortDescription: 'AR, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'AR',

      name: 'Appenzell Ausserrh.',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BE_CH,
      literal: 'BE_CH',
      description: 'Bern, Switzerland',
      shortDescription: 'BE, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'BE',

      name: 'Bern',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BL_CH,
      literal: 'BL_CH',
      description: 'Basel Land, Switzerland',
      shortDescription: 'BL, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'BL',

      name: 'Basel Land',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BS_CH,
      literal: 'BS_CH',
      description: 'Basel Stadt, Switzerland',
      shortDescription: 'BS, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'BS',

      name: 'Basel Stadt',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.FR_CH,
      literal: 'FR_CH',
      description: 'Fribourg, Switzerland',
      shortDescription: 'FR, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'FR',

      name: 'Fribourg',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GE_CH,
      literal: 'GE_CH',
      description: 'Geneva, Switzerland',
      shortDescription: 'GE, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'GE',

      name: 'Geneva',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GL_CH,
      literal: 'GL_CH',
      description: 'Glarus, Switzerland',
      shortDescription: 'GL, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'GL',

      name: 'Glarus',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GR_CH,
      literal: 'GR_CH',
      description: 'Graubuenden, Switzerland',
      shortDescription: 'GR, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'GR',

      name: 'Graubuenden',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.JU_CH,
      literal: 'JU_CH',
      description: 'Jura, Switzerland',
      shortDescription: 'JU, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'JU',

      name: 'Jura',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LU_CH,
      literal: 'LU_CH',
      description: 'Lucerne, Switzerland',
      shortDescription: 'LU, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'LU',

      name: 'Lucerne',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NE_CH,
      literal: 'NE_CH',
      description: 'Neuchatel, Switzerland',
      shortDescription: 'NE, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'NE',

      name: 'Neuchatel',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NW_CH,
      literal: 'NW_CH',
      description: 'Nidwalden, Switzerland',
      shortDescription: 'NW, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'NW',

      name: 'Nidwalden',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.OW_CH,
      literal: 'OW_CH',
      description: 'Obwalden, Switzerland',
      shortDescription: 'OW, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'OW',

      name: 'Obwalden',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SG_CH,
      literal: 'SG_CH',
      description: 'St. Gallen, Switzerland',
      shortDescription: 'SG, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'SG',

      name: 'St. Gallen',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SH_CH,
      literal: 'SH_CH',
      description: 'Schaffhausen, Switzerland',
      shortDescription: 'SH, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'SH',

      name: 'Schaffhausen',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SO_CH,
      literal: 'SO_CH',
      description: 'Solothurn, Switzerland',
      shortDescription: 'SO, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'SO',

      name: 'Solothurn',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SZ_CH,
      literal: 'SZ_CH',
      description: 'Switzerland, Switzerland',
      shortDescription: 'SZ, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'SZ',

      name: 'Switzerland',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TG_CH,
      literal: 'TG_CH',
      description: 'Thurgau, Switzerland',
      shortDescription: 'TG, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'TG',

      name: 'Thurgau',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TI_CH,
      literal: 'TI_CH',
      description: 'Ticino, Switzerland',
      shortDescription: 'TI, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'TI',

      name: 'Ticino',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.UR_CH,
      literal: 'UR_CH',
      description: 'Uri, Switzerland',
      shortDescription: 'UR, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'UR',

      name: 'Uri',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.VD_CH,
      literal: 'VD_CH',
      description: 'Vaud, Switzerland',
      shortDescription: 'VD, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'VD',

      name: 'Vaud',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.VS_CH,
      literal: 'VS_CH',
      description: 'Valais, Switzerland',
      shortDescription: 'VS, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'VS',

      name: 'Valais',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ZG_CH,
      literal: 'ZG_CH',
      description: 'Zug, Switzerland',
      shortDescription: 'ZG, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'ZG',

      name: 'Zug',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ZH_CH,
      literal: 'ZH_CH',
      description: 'Zurich, Switzerland',
      shortDescription: 'ZH, CH',
      listPriority: 0,

      countryCode: 40,

      standardCode: 'ZH',

      name: 'Zurich',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AM_GB,
      literal: 'AM_GB',
      description: 'Armagh, United Kingdom',
      shortDescription: 'AM, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'AM',

      name: 'Armagh',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AR_GB,
      literal: 'AR_GB',
      description: 'Ards, United Kingdom',
      shortDescription: 'AR, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'AR',

      name: 'Ards',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AT_GB,
      literal: 'AT_GB',
      description: 'Antrim, United Kingdom',
      shortDescription: 'AT, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'AT',

      name: 'Antrim',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BA_GB,
      literal: 'BA_GB',
      description: 'Ballymena, United Kingdom',
      shortDescription: 'BA, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'BA',

      name: 'Ballymena',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BB_GB,
      literal: 'BB_GB',
      description: 'Blackburn, United Kingdom',
      shortDescription: 'BB, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'BB',

      name: 'Blackburn',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BE_GB,
      literal: 'BE_GB',
      description: 'Bedfordshire, United Kingdom',
      shortDescription: 'BE, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'BE',

      name: 'Bedfordshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BF_GB,
      literal: 'BF_GB',
      description: 'Bracknell Forest, United Kingdom',
      shortDescription: 'BF, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'BF',

      name: 'Bracknell Forest',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BH_GB,
      literal: 'BH_GB',
      description: 'Brighton & Hove, United Kingdom',
      shortDescription: 'BH, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'BH',

      name: 'Brighton & Hove',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BK_GB,
      literal: 'BK_GB',
      description: 'Berkshire, United Kingdom',
      shortDescription: 'BK, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'BK',

      name: 'Berkshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BL_GB,
      literal: 'BL_GB',
      description: 'Belfast, United Kingdom',
      shortDescription: 'BL, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'BL',

      name: 'Belfast',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BM_GB,
      literal: 'BM_GB',
      description: 'Bournemouth, United Kingdom',
      shortDescription: 'BM, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'BM',

      name: 'Bournemouth',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BN_GB,
      literal: 'BN_GB',
      description: 'Banbridge, United Kingdom',
      shortDescription: 'BN, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'BN',

      name: 'Banbridge',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BO_GB,
      literal: 'BO_GB',
      description: 'Borders, United Kingdom',
      shortDescription: 'BO, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'BO',

      name: 'Borders',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BP_GB,
      literal: 'BP_GB',
      description: 'Blackpool, United Kingdom',
      shortDescription: 'BP, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'BP',

      name: 'Blackpool',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BR_GB,
      literal: 'BR_GB',
      description: 'Bristol, United Kingdom',
      shortDescription: 'BR, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'BR',

      name: 'Bristol',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BS_GB,
      literal: 'BS_GB',
      description: 'Bath&nthestsomerset, United Kingdom',
      shortDescription: 'BS, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'BS',

      name: 'Bath&nthestsomerset',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BU_GB,
      literal: 'BU_GB',
      description: 'Buckinghamshire, United Kingdom',
      shortDescription: 'BU, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'BU',

      name: 'Buckinghamshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BY_GB,
      literal: 'BY_GB',
      description: 'Ballymoney, United Kingdom',
      shortDescription: 'BY, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'BY',

      name: 'Ballymoney',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CA_GB,
      literal: 'CA_GB',
      description: 'Cambridgeshire, United Kingdom',
      shortDescription: 'CA, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'CA',

      name: 'Cambridgeshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CE_GB,
      literal: 'CE_GB',
      description: 'Central, United Kingdom',
      shortDescription: 'CE, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'CE',

      name: 'Central',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CG_GB,
      literal: 'CG_GB',
      description: 'Craigavon, United Kingdom',
      shortDescription: 'CG, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'CG',

      name: 'Craigavon',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CH_GB,
      literal: 'CH_GB',
      description: 'Cheshire, United Kingdom',
      shortDescription: 'CH, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'CH',

      name: 'Cheshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CI_GB,
      literal: 'CI_GB',
      description: 'Coleraine, United Kingdom',
      shortDescription: 'CI, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'CI',

      name: 'Coleraine',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CK_GB,
      literal: 'CK_GB',
      description: 'Cookstown, United Kingdom',
      shortDescription: 'CK, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'CK',

      name: 'Cookstown',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CL_GB,
      literal: 'CL_GB',
      description: 'Clwyd, United Kingdom',
      shortDescription: 'CL, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'CL',

      name: 'Clwyd',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CO_GB,
      literal: 'CO_GB',
      description: 'Cornwall, United Kingdom',
      shortDescription: 'CO, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'CO',

      name: 'Cornwall',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CR_GB,
      literal: 'CR_GB',
      description: 'Carrickfergus, United Kingdom',
      shortDescription: 'CR, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'CR',

      name: 'Carrickfergus',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CS_GB,
      literal: 'CS_GB',
      description: 'Castlereagh, United Kingdom',
      shortDescription: 'CS, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'CS',

      name: 'Castlereagh',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CU_GB,
      literal: 'CU_GB',
      description: 'Cumbria, United Kingdom',
      shortDescription: 'CU, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'CU',

      name: 'Cumbria',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CV_GB,
      literal: 'CV_GB',
      description: 'Cleveland, United Kingdom',
      shortDescription: 'CV, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'CV',

      name: 'Cleveland',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.DB_GB,
      literal: 'DB_GB',
      description: 'Derbyshire, United Kingdom',
      shortDescription: 'DB, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'DB',

      name: 'Derbyshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.DF_GB,
      literal: 'DF_GB',
      description: 'Dumfries A. Galloway, United Kingdom',
      shortDescription: 'DF, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'DF',

      name: 'Dumfries A. Galloway',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.DG_GB,
      literal: 'DG_GB',
      description: 'Dungannon, United Kingdom',
      shortDescription: 'DG, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'DG',

      name: 'Dungannon',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.DL_GB,
      literal: 'DL_GB',
      description: 'Darlington, United Kingdom',
      shortDescription: 'DL, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'DL',

      name: 'Darlington',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.DN_GB,
      literal: 'DN_GB',
      description: 'Down, United Kingdom',
      shortDescription: 'DN, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'DN',

      name: 'Down',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.DO_GB,
      literal: 'DO_GB',
      description: 'Dorset, United Kingdom',
      shortDescription: 'DO, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'DO',

      name: 'Dorset',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.DU_GB,
      literal: 'DU_GB',
      description: 'Durham, United Kingdom',
      shortDescription: 'DU, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'DU',

      name: 'Durham',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.DV_GB,
      literal: 'DV_GB',
      description: 'Devon, United Kingdom',
      shortDescription: 'DV, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'DV',

      name: 'Devon',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.DY_GB,
      literal: 'DY_GB',
      description: 'Dyfed, United Kingdom',
      shortDescription: 'DY, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'DY',

      name: 'Dyfed',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ER_GB,
      literal: 'ER_GB',
      description: 'East Riding, United Kingdom',
      shortDescription: 'ER, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'ER',

      name: 'East Riding',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ES_GB,
      literal: 'ES_GB',
      description: 'Essex, United Kingdom',
      shortDescription: 'ES, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'ES',

      name: 'Essex',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.FI_GB,
      literal: 'FI_GB',
      description: 'Fife, United Kingdom',
      shortDescription: 'FI, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'FI',

      name: 'Fife',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.FM_GB,
      literal: 'FM_GB',
      description: 'Fermanagh, United Kingdom',
      shortDescription: 'FM, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'FM',

      name: 'Fermanagh',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GL_GB,
      literal: 'GL_GB',
      description: 'Gloucestershire, United Kingdom',
      shortDescription: 'GL, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'GL',

      name: 'Gloucestershire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GM_GB,
      literal: 'GM_GB',
      description: 'Greater Manchester, United Kingdom',
      shortDescription: 'GM, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'GM',

      name: 'Greater Manchester',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GR_GB,
      literal: 'GR_GB',
      description: 'Grampian, United Kingdom',
      shortDescription: 'GR, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'GR',

      name: 'Grampian',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GS_GB,
      literal: 'GS_GB',
      description: 'Sth. Gloucestershire, United Kingdom',
      shortDescription: 'GS, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'GS',

      name: 'Sth. Gloucestershire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GW_GB,
      literal: 'GW_GB',
      description: 'Gwent, United Kingdom',
      shortDescription: 'GW, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'GW',

      name: 'Gwent',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GY_GB,
      literal: 'GY_GB',
      description: 'Gwynedd, United Kingdom',
      shortDescription: 'GY, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'GY',

      name: 'Gwynedd',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.HA_GB,
      literal: 'HA_GB',
      description: 'Hampshire, United Kingdom',
      shortDescription: 'HA, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'HA',

      name: 'Hampshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.HI_GB,
      literal: 'HI_GB',
      description: 'Highland, United Kingdom',
      shortDescription: 'HI, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'HI',

      name: 'Highland',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.HL_GB,
      literal: 'HL_GB',
      description: 'Halton, United Kingdom',
      shortDescription: 'HL, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'HL',

      name: 'Halton',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.HR_GB,
      literal: 'HR_GB',
      description: 'Hartlepool, United Kingdom',
      shortDescription: 'HR, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'HR',

      name: 'Hartlepool',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.HT_GB,
      literal: 'HT_GB',
      description: 'Hertfordshire, United Kingdom',
      shortDescription: 'HT, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'HT',

      name: 'Hertfordshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.HW_GB,
      literal: 'HW_GB',
      description: 'Herefd. And Worcest., United Kingdom',
      shortDescription: 'HW, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'HW',

      name: 'Herefd. And Worcest.',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.IW_GB,
      literal: 'IW_GB',
      description: 'Isle Of Wight, United Kingdom',
      shortDescription: 'IW, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'IW',

      name: 'Isle Of Wight',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.KE_GB,
      literal: 'KE_GB',
      description: 'Kent, United Kingdom',
      shortDescription: 'KE, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'KE',

      name: 'Kent',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.KH_GB,
      literal: 'KH_GB',
      description: 'Kingston-Upon-Hull, United Kingdom',
      shortDescription: 'KH, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'KH',

      name: 'Kingston-Upon-Hull',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LA_GB,
      literal: 'LA_GB',
      description: 'Lancashire, United Kingdom',
      shortDescription: 'LA, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'LA',

      name: 'Lancashire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LC_GB,
      literal: 'LC_GB',
      description: 'Leicester City, United Kingdom',
      shortDescription: 'LC, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'LC',

      name: 'Leicester City',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LD_GB,
      literal: 'LD_GB',
      description: 'Londonderry, United Kingdom',
      shortDescription: 'LD, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'LD',

      name: 'Londonderry',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LE_GB,
      literal: 'LE_GB',
      description: 'Leicestershire, United Kingdom',
      shortDescription: 'LE, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'LE',

      name: 'Leicestershire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LI_GB,
      literal: 'LI_GB',
      description: 'Lincolnshire, United Kingdom',
      shortDescription: 'LI, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'LI',

      name: 'Lincolnshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LM_GB,
      literal: 'LM_GB',
      description: 'Limavady, United Kingdom',
      shortDescription: 'LM, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'LM',

      name: 'Limavady',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LO_GB,
      literal: 'LO_GB',
      description: 'Greater London, United Kingdom',
      shortDescription: 'LO, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'LO',

      name: 'Greater London',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LR_GB,
      literal: 'LR_GB',
      description: 'Larne, United Kingdom',
      shortDescription: 'LR, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'LR',

      name: 'Larne',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LS_GB,
      literal: 'LS_GB',
      description: 'Lisburn, United Kingdom',
      shortDescription: 'LS, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'LS',

      name: 'Lisburn',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LT_GB,
      literal: 'LT_GB',
      description: 'Lothian, United Kingdom',
      shortDescription: 'LT, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'LT',

      name: 'Lothian',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LU_GB,
      literal: 'LU_GB',
      description: 'Luton, United Kingdom',
      shortDescription: 'LU, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'LU',

      name: 'Luton',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MA_GB,
      literal: 'MA_GB',
      description: 'Magherafelt, United Kingdom',
      shortDescription: 'MA, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'MA',

      name: 'Magherafelt',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MG_GB,
      literal: 'MG_GB',
      description: 'Mid Glamorgan, United Kingdom',
      shortDescription: 'MG, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'MG',

      name: 'Mid Glamorgan',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MI_GB,
      literal: 'MI_GB',
      description: 'Middlesbrough, United Kingdom',
      shortDescription: 'MI, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'MI',

      name: 'Middlesbrough',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MK_GB,
      literal: 'MK_GB',
      description: 'Milton Keynes, United Kingdom',
      shortDescription: 'MK, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'MK',

      name: 'Milton Keynes',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MO_GB,
      literal: 'MO_GB',
      description: 'Moyle, United Kingdom',
      shortDescription: 'MO, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'MO',

      name: 'Moyle',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MY_GB,
      literal: 'MY_GB',
      description: 'Merseyside, United Kingdom',
      shortDescription: 'MY, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'MY',

      name: 'Merseyside',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NA_GB,
      literal: 'NA_GB',
      description: 'Newtownabbey, United Kingdom',
      shortDescription: 'NA, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'NA',

      name: 'Newtownabbey',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NB_GB,
      literal: 'NB_GB',
      description: 'Newbury, United Kingdom',
      shortDescription: 'NB, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'NB',

      name: 'Newbury',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NC_GB,
      literal: 'NC_GB',
      description: 'Nottingham City, United Kingdom',
      shortDescription: 'NC, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'NC',

      name: 'Nottingham City',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ND_GB,
      literal: 'ND_GB',
      description: 'North Down, United Kingdom',
      shortDescription: 'ND, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'ND',

      name: 'North Down',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NE_GB,
      literal: 'NE_GB',
      description: 'Ntheast Lincolnshire, United Kingdom',
      shortDescription: 'NE, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'NE',

      name: 'Ntheast Lincolnshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NH_GB,
      literal: 'NH_GB',
      description: 'Northamptonshire, United Kingdom',
      shortDescription: 'NH, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'NH',

      name: 'Northamptonshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NK_GB,
      literal: 'NK_GB',
      description: 'Norfolk, United Kingdom',
      shortDescription: 'NK, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'NK',

      name: 'Norfolk',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NL_GB,
      literal: 'NL_GB',
      description: 'North Lincolnshire, United Kingdom',
      shortDescription: 'NL, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'NL',

      name: 'North Lincolnshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NM_GB,
      literal: 'NM_GB',
      description: 'Newry And Mourne, United Kingdom',
      shortDescription: 'NM, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'NM',

      name: 'Newry And Mourne',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NS_GB,
      literal: 'NS_GB',
      description: 'North Somerset, United Kingdom',
      shortDescription: 'NS, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'NS',

      name: 'North Somerset',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NT_GB,
      literal: 'NT_GB',
      description: 'Nottinghamshire, United Kingdom',
      shortDescription: 'NT, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'NT',

      name: 'Nottinghamshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NU_GB,
      literal: 'NU_GB',
      description: 'Northumberland, United Kingdom',
      shortDescription: 'NU, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'NU',

      name: 'Northumberland',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.OM_GB,
      literal: 'OM_GB',
      description: 'Omagh, United Kingdom',
      shortDescription: 'OM, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'OM',

      name: 'Omagh',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.OR_GB,
      literal: 'OR_GB',
      description: 'Orkney, United Kingdom',
      shortDescription: 'OR, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'OR',

      name: 'Orkney',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.OX_GB,
      literal: 'OX_GB',
      description: 'Oxfordshire, United Kingdom',
      shortDescription: 'OX, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'OX',

      name: 'Oxfordshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PB_GB,
      literal: 'PB_GB',
      description: 'Peterborough, United Kingdom',
      shortDescription: 'PB, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'PB',

      name: 'Peterborough',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PL_GB,
      literal: 'PL_GB',
      description: 'Poole, United Kingdom',
      shortDescription: 'PL, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'PL',

      name: 'Poole',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PM_GB,
      literal: 'PM_GB',
      description: 'Portsmouth, United Kingdom',
      shortDescription: 'PM, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'PM',

      name: 'Portsmouth',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PO_GB,
      literal: 'PO_GB',
      description: 'Powys, United Kingdom',
      shortDescription: 'PO, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'PO',

      name: 'Powys',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PY_GB,
      literal: 'PY_GB',
      description: 'Plymouth, United Kingdom',
      shortDescription: 'PY, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'PY',

      name: 'Plymouth',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.RD_GB,
      literal: 'RD_GB',
      description: 'Redcar And Cleveland, United Kingdom',
      shortDescription: 'RD, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'RD',

      name: 'Redcar And Cleveland',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.RE_GB,
      literal: 'RE_GB',
      description: 'Reading, United Kingdom',
      shortDescription: 'RE, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'RE',

      name: 'Reading',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.RM_GB,
      literal: 'RM_GB',
      description: 'Rochester Up. Medway, United Kingdom',
      shortDescription: 'RM, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'RM',

      name: 'Rochester Up. Medway',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.RU_GB,
      literal: 'RU_GB',
      description: 'Rutland, United Kingdom',
      shortDescription: 'RU, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'RU',

      name: 'Rutland',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SC_GB,
      literal: 'SC_GB',
      description: 'Strathclyde, United Kingdom',
      shortDescription: 'SC, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'SC',

      name: 'Strathclyde',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SD_GB,
      literal: 'SD_GB',
      description: 'Southend, United Kingdom',
      shortDescription: 'SD, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'SD',

      name: 'Southend',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SE_GB,
      literal: 'SE_GB',
      description: 'East Sussex, United Kingdom',
      shortDescription: 'SE, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'SE',

      name: 'East Sussex',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SG_GB,
      literal: 'SG_GB',
      description: 'South Glamorgan, United Kingdom',
      shortDescription: 'SG, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'SG',

      name: 'South Glamorgan',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SH_GB,
      literal: 'SH_GB',
      description: 'Shropshire, United Kingdom',
      shortDescription: 'SH, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'SH',

      name: 'Shropshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SK_GB,
      literal: 'SK_GB',
      description: 'Suffolk, United Kingdom',
      shortDescription: 'SK, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'SK',

      name: 'Suffolk',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SL_GB,
      literal: 'SL_GB',
      description: 'Shetland, United Kingdom',
      shortDescription: 'SL, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'SL',

      name: 'Shetland',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SN_GB,
      literal: 'SN_GB',
      description: 'Stockton-On-Tees, United Kingdom',
      shortDescription: 'SN, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'SN',

      name: 'Stockton-On-Tees',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SO_GB,
      literal: 'SO_GB',
      description: 'Somerset, United Kingdom',
      shortDescription: 'SO, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'SO',

      name: 'Somerset',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SP_GB,
      literal: 'SP_GB',
      description: 'Southampton, United Kingdom',
      shortDescription: 'SP, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'SP',

      name: 'Southampton',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SR_GB,
      literal: 'SR_GB',
      description: 'Strabane, United Kingdom',
      shortDescription: 'SR, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'SR',

      name: 'Strabane',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ST_GB,
      literal: 'ST_GB',
      description: 'Staffordshire, United Kingdom',
      shortDescription: 'ST, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'ST',

      name: 'Staffordshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SU_GB,
      literal: 'SU_GB',
      description: 'Slough, United Kingdom',
      shortDescription: 'SU, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'SU',

      name: 'Slough',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SW_GB,
      literal: 'SW_GB',
      description: 'West Sussex, United Kingdom',
      shortDescription: 'SW, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'SW',

      name: 'West Sussex',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SY_GB,
      literal: 'SY_GB',
      description: 'Surrey, United Kingdom',
      shortDescription: 'SY, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'SY',

      name: 'Surrey',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TA_GB,
      literal: 'TA_GB',
      description: 'Tayside, United Kingdom',
      shortDescription: 'TA, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'TA',

      name: 'Tayside',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TD_GB,
      literal: 'TD_GB',
      description: 'Thamesdown, United Kingdom',
      shortDescription: 'TD, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'TD',

      name: 'Thamesdown',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TH_GB,
      literal: 'TH_GB',
      description: 'Thurrock, United Kingdom',
      shortDescription: 'TH, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'TH',

      name: 'Thurrock',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TO_GB,
      literal: 'TO_GB',
      description: 'Torbay, United Kingdom',
      shortDescription: 'TO, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'TO',

      name: 'Torbay',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TW_GB,
      literal: 'TW_GB',
      description: 'Tyne And Wear, United Kingdom',
      shortDescription: 'TW, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'TW',

      name: 'Tyne And Wear',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WA_GB,
      literal: 'WA_GB',
      description: 'Warwickshire, United Kingdom',
      shortDescription: 'WA, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'WA',

      name: 'Warwickshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WD_GB,
      literal: 'WD_GB',
      description: 'Windsor & Maidenhead, United Kingdom',
      shortDescription: 'WD, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'WD',

      name: 'Windsor & Maidenhead',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WG_GB,
      literal: 'WG_GB',
      description: 'West Glamorgan, United Kingdom',
      shortDescription: 'WG, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'WG',

      name: 'West Glamorgan',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WI_GB,
      literal: 'WI_GB',
      description: 'Wiltshire, United Kingdom',
      shortDescription: 'WI, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'WI',

      name: 'Wiltshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WL_GB,
      literal: 'WL_GB',
      description: 'Western Isles, United Kingdom',
      shortDescription: 'WL, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'WL',

      name: 'Western Isles',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WM_GB,
      literal: 'WM_GB',
      description: 'West Midlands, United Kingdom',
      shortDescription: 'WM, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'WM',

      name: 'West Midlands',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WO_GB,
      literal: 'WO_GB',
      description: 'Wokingham, United Kingdom',
      shortDescription: 'WO, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'WO',

      name: 'Wokingham',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WR_GB,
      literal: 'WR_GB',
      description: 'Wrekin, United Kingdom',
      shortDescription: 'WR, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'WR',

      name: 'Wrekin',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WT_GB,
      literal: 'WT_GB',
      description: 'Warrington, United Kingdom',
      shortDescription: 'WT, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'WT',

      name: 'Warrington',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.YK_GB,
      literal: 'YK_GB',
      description: 'York, United Kingdom',
      shortDescription: 'YK, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'YK',

      name: 'York',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.YN_GB,
      literal: 'YN_GB',
      description: 'North Yorkshire, United Kingdom',
      shortDescription: 'YN, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'YN',

      name: 'North Yorkshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.YS_GB,
      literal: 'YS_GB',
      description: 'South Yorkshire, United Kingdom',
      shortDescription: 'YS, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'YS',

      name: 'South Yorkshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.YW_GB,
      literal: 'YW_GB',
      description: 'West Yorkshire, United Kingdom',
      shortDescription: 'YW, GB',
      listPriority: 0,

      countryCode: 72,

      standardCode: 'YW',

      name: 'West Yorkshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.HK_HK,
      literal: 'HK_HK',
      description: 'Hong Kong Island, Hong Kong',
      shortDescription: 'HK, HK',
      listPriority: 0,

      countryCode: 89,

      standardCode: 'HK',

      name: 'Hong Kong Island',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.KLN_HK,
      literal: 'KLN_HK',
      description: 'Kowloon, Hong Kong',
      shortDescription: 'KLN, HK',
      listPriority: 0,

      countryCode: 89,

      standardCode: 'KLN',

      name: 'Kowloon',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NT_HK,
      literal: 'NT_HK',
      description: 'New Territories, Hong Kong',
      shortDescription: 'NT, HK',
      listPriority: 0,

      countryCode: 89,

      standardCode: 'NT',

      name: 'New Territories',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CK_IE,
      literal: 'CK_IE',
      description: 'Cork, Ireland',
      shortDescription: 'CK, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'CK',

      name: 'Cork',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CL_IE,
      literal: 'CL_IE',
      description: 'Clare, Ireland',
      shortDescription: 'CL, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'CL',

      name: 'Clare',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CW_IE,
      literal: 'CW_IE',
      description: 'Carlow, Ireland',
      shortDescription: 'CW, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'CW',

      name: 'Carlow',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.DB_IE,
      literal: 'DB_IE',
      description: 'Dublin, Ireland',
      shortDescription: 'DB, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'DB',

      name: 'Dublin',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.DG_IE,
      literal: 'DG_IE',
      description: 'Donegal, Ireland',
      shortDescription: 'DG, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'DG',

      name: 'Donegal',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GW_IE,
      literal: 'GW_IE',
      description: 'Galway, Ireland',
      shortDescription: 'GW, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'GW',

      name: 'Galway',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.KD_IE,
      literal: 'KD_IE',
      description: 'Kildare, Ireland',
      shortDescription: 'KD, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'KD',

      name: 'Kildare',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.KK_IE,
      literal: 'KK_IE',
      description: 'Kilkenny, Ireland',
      shortDescription: 'KK, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'KK',

      name: 'Kilkenny',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.KV_IE,
      literal: 'KV_IE',
      description: 'Cavan, Ireland',
      shortDescription: 'KV, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'KV',

      name: 'Cavan',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.KY_IE,
      literal: 'KY_IE',
      description: 'Kerry, Ireland',
      shortDescription: 'KY, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'KY',

      name: 'Kerry',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LF_IE,
      literal: 'LF_IE',
      description: 'Longford, Ireland',
      shortDescription: 'LF, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'LF',

      name: 'Longford',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LI_IE,
      literal: 'LI_IE',
      description: 'Limerick, Ireland',
      shortDescription: 'LI, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'LI',

      name: 'Limerick',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LM_IE,
      literal: 'LM_IE',
      description: 'Leitrim, Ireland',
      shortDescription: 'LM, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'LM',

      name: 'Leitrim',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LS_IE,
      literal: 'LS_IE',
      description: 'Laois, Ireland',
      shortDescription: 'LS, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'LS',

      name: 'Laois',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LT_IE,
      literal: 'LT_IE',
      description: 'Louth, Ireland',
      shortDescription: 'LT, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'LT',

      name: 'Louth',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MH_IE,
      literal: 'MH_IE',
      description: 'Monaghan, Ireland',
      shortDescription: 'MH, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'MH',

      name: 'Monaghan',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MT_IE,
      literal: 'MT_IE',
      description: 'Meath, Ireland',
      shortDescription: 'MT, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'MT',

      name: 'Meath',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MY_IE,
      literal: 'MY_IE',
      description: 'Mayo, Ireland',
      shortDescription: 'MY, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'MY',

      name: 'Mayo',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.OS_IE,
      literal: 'OS_IE',
      description: 'Offaly, Ireland',
      shortDescription: 'OS, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'OS',

      name: 'Offaly',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.RC_IE,
      literal: 'RC_IE',
      description: 'Rosscommon, Ireland',
      shortDescription: 'RC, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'RC',

      name: 'Rosscommon',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SG_IE,
      literal: 'SG_IE',
      description: 'Sligo, Ireland',
      shortDescription: 'SG, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'SG',

      name: 'Sligo',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TP_IE,
      literal: 'TP_IE',
      description: 'Tipperary, Ireland',
      shortDescription: 'TP, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'TP',

      name: 'Tipperary',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WF_IE,
      literal: 'WF_IE',
      description: 'Waterford, Ireland',
      shortDescription: 'WF, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'WF',

      name: 'Waterford',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WK_IE,
      literal: 'WK_IE',
      description: 'Wicklow, Ireland',
      shortDescription: 'WK, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'WK',

      name: 'Wicklow',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WM_IE,
      literal: 'WM_IE',
      description: 'Westmeath, Ireland',
      shortDescription: 'WM, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'WM',

      name: 'Westmeath',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WX_IE,
      literal: 'WX_IE',
      description: 'Wexford, Ireland',
      shortDescription: 'WX, IE',
      listPriority: 0,

      countryCode: 96,

      standardCode: 'WX',

      name: 'Wexford',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AG_IT,
      literal: 'AG_IT',
      description: 'Agriento, Italy',
      shortDescription: 'AG, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'AG',

      name: 'Agriento',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AL_IT,
      literal: 'AL_IT',
      description: 'Alessandria, Italy',
      shortDescription: 'AL, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'AL',

      name: 'Alessandria',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AN_IT,
      literal: 'AN_IT',
      description: 'Ancona, Italy',
      shortDescription: 'AN, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'AN',

      name: 'Ancona',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AO_IT,
      literal: 'AO_IT',
      description: 'Aosta, Italy',
      shortDescription: 'AO, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'AO',

      name: 'Aosta',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AP_IT,
      literal: 'AP_IT',
      description: 'Ascoli Piceno, Italy',
      shortDescription: 'AP, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'AP',

      name: 'Ascoli Piceno',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AQ_IT,
      literal: 'AQ_IT',
      description: 'L\'aquila, Italy',
      shortDescription: 'AQ, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'AQ',

      name: 'L\'aquila',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AR_IT,
      literal: 'AR_IT',
      description: 'Arezzo, Italy',
      shortDescription: 'AR, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'AR',

      name: 'Arezzo',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AT_IT,
      literal: 'AT_IT',
      description: 'Asti, Italy',
      shortDescription: 'AT, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'AT',

      name: 'Asti',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AV_IT,
      literal: 'AV_IT',
      description: 'Avellino, Italy',
      shortDescription: 'AV, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'AV',

      name: 'Avellino',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BA_IT,
      literal: 'BA_IT',
      description: 'Bari, Italy',
      shortDescription: 'BA, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'BA',

      name: 'Bari',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BG_IT,
      literal: 'BG_IT',
      description: 'Bergamo, Italy',
      shortDescription: 'BG, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'BG',

      name: 'Bergamo',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BI_IT,
      literal: 'BI_IT',
      description: 'Biella, Italy',
      shortDescription: 'BI, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'BI',

      name: 'Biella',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BL_IT,
      literal: 'BL_IT',
      description: 'Belluno, Italy',
      shortDescription: 'BL, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'BL',

      name: 'Belluno',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BN_IT,
      literal: 'BN_IT',
      description: 'Benevento, Italy',
      shortDescription: 'BN, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'BN',

      name: 'Benevento',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BO_IT,
      literal: 'BO_IT',
      description: 'Bologna, Italy',
      shortDescription: 'BO, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'BO',

      name: 'Bologna',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BR_IT,
      literal: 'BR_IT',
      description: 'Brindisi, Italy',
      shortDescription: 'BR, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'BR',

      name: 'Brindisi',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BS_IT,
      literal: 'BS_IT',
      description: 'Brescia, Italy',
      shortDescription: 'BS, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'BS',

      name: 'Brescia',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BZ_IT,
      literal: 'BZ_IT',
      description: 'Bolzano, Italy',
      shortDescription: 'BZ, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'BZ',

      name: 'Bolzano',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CA_IT,
      literal: 'CA_IT',
      description: 'Cagliari, Italy',
      shortDescription: 'CA, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'CA',

      name: 'Cagliari',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CB_IT,
      literal: 'CB_IT',
      description: 'Campobasso, Italy',
      shortDescription: 'CB, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'CB',

      name: 'Campobasso',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CE_IT,
      literal: 'CE_IT',
      description: 'Caserta, Italy',
      shortDescription: 'CE, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'CE',

      name: 'Caserta',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CH_IT,
      literal: 'CH_IT',
      description: 'Chieti, Italy',
      shortDescription: 'CH, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'CH',

      name: 'Chieti',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CL_IT,
      literal: 'CL_IT',
      description: 'Caltanisetta, Italy',
      shortDescription: 'CL, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'CL',

      name: 'Caltanisetta',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CN_IT,
      literal: 'CN_IT',
      description: 'Cuneo, Italy',
      shortDescription: 'CN, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'CN',

      name: 'Cuneo',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CO_IT,
      literal: 'CO_IT',
      description: 'Como, Italy',
      shortDescription: 'CO, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'CO',

      name: 'Como',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CR_IT,
      literal: 'CR_IT',
      description: 'Cremona, Italy',
      shortDescription: 'CR, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'CR',

      name: 'Cremona',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CS_IT,
      literal: 'CS_IT',
      description: 'Cosenza, Italy',
      shortDescription: 'CS, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'CS',

      name: 'Cosenza',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CT_IT,
      literal: 'CT_IT',
      description: 'Catania, Italy',
      shortDescription: 'CT, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'CT',

      name: 'Catania',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CZ_IT,
      literal: 'CZ_IT',
      description: 'Catanzaro, Italy',
      shortDescription: 'CZ, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'CZ',

      name: 'Catanzaro',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.EN_IT,
      literal: 'EN_IT',
      description: 'Enna, Italy',
      shortDescription: 'EN, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'EN',

      name: 'Enna',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.FE_IT,
      literal: 'FE_IT',
      description: 'Ferrara, Italy',
      shortDescription: 'FE, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'FE',

      name: 'Ferrara',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.FG_IT,
      literal: 'FG_IT',
      description: 'Foggia, Italy',
      shortDescription: 'FG, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'FG',

      name: 'Foggia',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.FI_IT,
      literal: 'FI_IT',
      description: 'Firenze, Italy',
      shortDescription: 'FI, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'FI',

      name: 'Firenze',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.FO_IT,
      literal: 'FO_IT',
      description: 'Forlì, Italy',
      shortDescription: 'FO, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'FO',

      name: 'Forlì',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.FR_IT,
      literal: 'FR_IT',
      description: 'Frosinone, Italy',
      shortDescription: 'FR, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'FR',

      name: 'Frosinone',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GE_IT,
      literal: 'GE_IT',
      description: 'Genova, Italy',
      shortDescription: 'GE, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'GE',

      name: 'Genova',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GO_IT,
      literal: 'GO_IT',
      description: 'Gorizia, Italy',
      shortDescription: 'GO, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'GO',

      name: 'Gorizia',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GR_IT,
      literal: 'GR_IT',
      description: 'Grosseto, Italy',
      shortDescription: 'GR, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'GR',

      name: 'Grosseto',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.IM_IT,
      literal: 'IM_IT',
      description: 'Imperia, Italy',
      shortDescription: 'IM, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'IM',

      name: 'Imperia',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.IS_IT,
      literal: 'IS_IT',
      description: 'Isernia, Italy',
      shortDescription: 'IS, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'IS',

      name: 'Isernia',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.KR_IT,
      literal: 'KR_IT',
      description: 'Crotone, Italy',
      shortDescription: 'KR, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'KR',

      name: 'Crotone',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LC_IT,
      literal: 'LC_IT',
      description: 'Lecco, Italy',
      shortDescription: 'LC, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'LC',

      name: 'Lecco',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LE_IT,
      literal: 'LE_IT',
      description: 'Lecce, Italy',
      shortDescription: 'LE, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'LE',

      name: 'Lecce',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LI_IT,
      literal: 'LI_IT',
      description: 'Livorno, Italy',
      shortDescription: 'LI, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'LI',

      name: 'Livorno',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LO_IT,
      literal: 'LO_IT',
      description: 'Lodi, Italy',
      shortDescription: 'LO, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'LO',

      name: 'Lodi',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LT_IT,
      literal: 'LT_IT',
      description: 'Latina, Italy',
      shortDescription: 'LT, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'LT',

      name: 'Latina',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LU_IT,
      literal: 'LU_IT',
      description: 'Lucca, Italy',
      shortDescription: 'LU, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'LU',

      name: 'Lucca',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MC_IT,
      literal: 'MC_IT',
      description: 'Macerata, Italy',
      shortDescription: 'MC, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'MC',

      name: 'Macerata',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ME_IT,
      literal: 'ME_IT',
      description: 'Messina, Italy',
      shortDescription: 'ME, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'ME',

      name: 'Messina',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MI_IT,
      literal: 'MI_IT',
      description: 'Milan, Italy',
      shortDescription: 'MI, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'MI',

      name: 'Milan',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MN_IT,
      literal: 'MN_IT',
      description: 'Mantova, Italy',
      shortDescription: 'MN, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'MN',

      name: 'Mantova',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MO_IT,
      literal: 'MO_IT',
      description: 'Modena, Italy',
      shortDescription: 'MO, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'MO',

      name: 'Modena',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MS_IT,
      literal: 'MS_IT',
      description: 'Massa Carrara, Italy',
      shortDescription: 'MS, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'MS',

      name: 'Massa Carrara',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MT_IT,
      literal: 'MT_IT',
      description: 'Matera, Italy',
      shortDescription: 'MT, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'MT',

      name: 'Matera',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NA_IT,
      literal: 'NA_IT',
      description: 'Napoli, Italy',
      shortDescription: 'NA, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'NA',

      name: 'Napoli',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NO_IT,
      literal: 'NO_IT',
      description: 'Novara, Italy',
      shortDescription: 'NO, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'NO',

      name: 'Novara',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NU_IT,
      literal: 'NU_IT',
      description: 'Nuoro, Italy',
      shortDescription: 'NU, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'NU',

      name: 'Nuoro',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.OR_IT,
      literal: 'OR_IT',
      description: 'Oristano, Italy',
      shortDescription: 'OR, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'OR',

      name: 'Oristano',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PA_IT,
      literal: 'PA_IT',
      description: 'Palermo, Italy',
      shortDescription: 'PA, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'PA',

      name: 'Palermo',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PC_IT,
      literal: 'PC_IT',
      description: 'Piacenza, Italy',
      shortDescription: 'PC, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'PC',

      name: 'Piacenza',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PD_IT,
      literal: 'PD_IT',
      description: 'Padova, Italy',
      shortDescription: 'PD, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'PD',

      name: 'Padova',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PE_IT,
      literal: 'PE_IT',
      description: 'Pescara, Italy',
      shortDescription: 'PE, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'PE',

      name: 'Pescara',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PG_IT,
      literal: 'PG_IT',
      description: 'Perugia, Italy',
      shortDescription: 'PG, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'PG',

      name: 'Perugia',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PI_IT,
      literal: 'PI_IT',
      description: 'Pisa, Italy',
      shortDescription: 'PI, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'PI',

      name: 'Pisa',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PN_IT,
      literal: 'PN_IT',
      description: 'Pordenone, Italy',
      shortDescription: 'PN, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'PN',

      name: 'Pordenone',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PO_IT,
      literal: 'PO_IT',
      description: 'Prato, Italy',
      shortDescription: 'PO, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'PO',

      name: 'Prato',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PR_IT,
      literal: 'PR_IT',
      description: 'Parma, Italy',
      shortDescription: 'PR, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'PR',

      name: 'Parma',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PS_IT,
      literal: 'PS_IT',
      description: 'Pesaro, Italy',
      shortDescription: 'PS, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'PS',

      name: 'Pesaro',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PT_IT,
      literal: 'PT_IT',
      description: 'Pistoia, Italy',
      shortDescription: 'PT, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'PT',

      name: 'Pistoia',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PV_IT,
      literal: 'PV_IT',
      description: 'Pavia, Italy',
      shortDescription: 'PV, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'PV',

      name: 'Pavia',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PZ_IT,
      literal: 'PZ_IT',
      description: 'Potenza, Italy',
      shortDescription: 'PZ, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'PZ',

      name: 'Potenza',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.RA_IT,
      literal: 'RA_IT',
      description: 'Ravenna, Italy',
      shortDescription: 'RA, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'RA',

      name: 'Ravenna',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.RC_IT,
      literal: 'RC_IT',
      description: 'Reggio Calabria, Italy',
      shortDescription: 'RC, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'RC',

      name: 'Reggio Calabria',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.RE_IT,
      literal: 'RE_IT',
      description: 'Reggio Emilia, Italy',
      shortDescription: 'RE, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'RE',

      name: 'Reggio Emilia',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.RG_IT,
      literal: 'RG_IT',
      description: 'Ragusa, Italy',
      shortDescription: 'RG, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'RG',

      name: 'Ragusa',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.RI_IT,
      literal: 'RI_IT',
      description: 'Rieti, Italy',
      shortDescription: 'RI, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'RI',

      name: 'Rieti',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.RM_IT,
      literal: 'RM_IT',
      description: 'Rome, Italy',
      shortDescription: 'RM, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'RM',

      name: 'Rome',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.RN_IT,
      literal: 'RN_IT',
      description: 'Rimini, Italy',
      shortDescription: 'RN, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'RN',

      name: 'Rimini',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.RO_IT,
      literal: 'RO_IT',
      description: 'Rovigo, Italy',
      shortDescription: 'RO, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'RO',

      name: 'Rovigo',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.RV_IT,
      literal: 'RV_IT',
      description: 'Rovigo, Italy',
      shortDescription: 'RV, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'RV',

      name: 'Rovigo',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SA_IT,
      literal: 'SA_IT',
      description: 'Salerno, Italy',
      shortDescription: 'SA, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'SA',

      name: 'Salerno',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SI_IT,
      literal: 'SI_IT',
      description: 'Siena, Italy',
      shortDescription: 'SI, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'SI',

      name: 'Siena',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SO_IT,
      literal: 'SO_IT',
      description: 'Sondrio, Italy',
      shortDescription: 'SO, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'SO',

      name: 'Sondrio',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SP_IT,
      literal: 'SP_IT',
      description: 'La Spezia, Italy',
      shortDescription: 'SP, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'SP',

      name: 'La Spezia',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SR_IT,
      literal: 'SR_IT',
      description: 'Siracusa, Italy',
      shortDescription: 'SR, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'SR',

      name: 'Siracusa',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SS_IT,
      literal: 'SS_IT',
      description: 'Sassari, Italy',
      shortDescription: 'SS, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'SS',

      name: 'Sassari',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SV_IT,
      literal: 'SV_IT',
      description: 'Savona, Italy',
      shortDescription: 'SV, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'SV',

      name: 'Savona',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TA_IT,
      literal: 'TA_IT',
      description: 'Taranto, Italy',
      shortDescription: 'TA, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'TA',

      name: 'Taranto',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TE_IT,
      literal: 'TE_IT',
      description: 'Teramo, Italy',
      shortDescription: 'TE, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'TE',

      name: 'Teramo',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TN_IT,
      literal: 'TN_IT',
      description: 'Trento, Italy',
      shortDescription: 'TN, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'TN',

      name: 'Trento',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TO_IT,
      literal: 'TO_IT',
      description: 'Turin, Italy',
      shortDescription: 'TO, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'TO',

      name: 'Turin',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TP_IT,
      literal: 'TP_IT',
      description: 'Trapani, Italy',
      shortDescription: 'TP, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'TP',

      name: 'Trapani',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TR_IT,
      literal: 'TR_IT',
      description: 'Terni, Italy',
      shortDescription: 'TR, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'TR',

      name: 'Terni',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TS_IT,
      literal: 'TS_IT',
      description: 'Trieste, Italy',
      shortDescription: 'TS, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'TS',

      name: 'Trieste',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TV_IT,
      literal: 'TV_IT',
      description: 'Treviso, Italy',
      shortDescription: 'TV, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'TV',

      name: 'Treviso',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.UD_IT,
      literal: 'UD_IT',
      description: 'Udine, Italy',
      shortDescription: 'UD, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'UD',

      name: 'Udine',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.VA_IT,
      literal: 'VA_IT',
      description: 'Varese, Italy',
      shortDescription: 'VA, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'VA',

      name: 'Varese',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.VC_IT,
      literal: 'VC_IT',
      description: 'Vercelli, Italy',
      shortDescription: 'VC, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'VC',

      name: 'Vercelli',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.VE_IT,
      literal: 'VE_IT',
      description: 'Venice, Italy',
      shortDescription: 'VE, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'VE',

      name: 'Venice',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.VI_IT,
      literal: 'VI_IT',
      description: 'Vicenza, Italy',
      shortDescription: 'VI, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'VI',

      name: 'Vicenza',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.VR_IT,
      literal: 'VR_IT',
      description: 'Verona, Italy',
      shortDescription: 'VR, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'VR',

      name: 'Verona',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.VT_IT,
      literal: 'VT_IT',
      description: 'Viterbo, Italy',
      shortDescription: 'VT, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'VT',

      name: 'Viterbo',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.VV_IT,
      literal: 'VV_IT',
      description: 'Vibo Valentia, Italy',
      shortDescription: 'VV, IT',
      listPriority: 0,

      countryCode: 103,

      standardCode: 'VV',

      name: 'Vibo Valentia',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AGS_MX,
      literal: 'AGS_MX',
      description: 'Aguascalientes, Mexico',
      shortDescription: 'AGS, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'AGS',

      name: 'Aguascalientes',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BCN_MX,
      literal: 'BCN_MX',
      description: 'Baja California N, Mexico',
      shortDescription: 'BCN, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'BCN',

      name: 'Baja California N',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.BCS_MX,
      literal: 'BCS_MX',
      description: 'Baja California S, Mexico',
      shortDescription: 'BCS, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'BCS',

      name: 'Baja California S',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CHI_MX,
      literal: 'CHI_MX',
      description: 'Chihuahua, Mexico',
      shortDescription: 'CHI, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'CHI',

      name: 'Chihuahua',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CHS_MX,
      literal: 'CHS_MX',
      description: 'Chiapas, Mexico',
      shortDescription: 'CHS, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'CHS',

      name: 'Chiapas',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CMP_MX,
      literal: 'CMP_MX',
      description: 'Campeche, Mexico',
      shortDescription: 'CMP, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'CMP',

      name: 'Campeche',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.COA_MX,
      literal: 'COA_MX',
      description: 'Coahuila, Mexico',
      shortDescription: 'COA, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'COA',

      name: 'Coahuila',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.COL_MX,
      literal: 'COL_MX',
      description: 'Colima, Mexico',
      shortDescription: 'COL, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'COL',

      name: 'Colima',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.DF_MX,
      literal: 'DF_MX',
      description: 'Distrito Federal, Mexico',
      shortDescription: 'DF, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'DF',

      name: 'Distrito Federal',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.DGO_MX,
      literal: 'DGO_MX',
      description: 'Durango, Mexico',
      shortDescription: 'DGO, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'DGO',

      name: 'Durango',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GRO_MX,
      literal: 'GRO_MX',
      description: 'Guerrero, Mexico',
      shortDescription: 'GRO, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'GRO',

      name: 'Guerrero',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GTO_MX,
      literal: 'GTO_MX',
      description: 'Guanajuato, Mexico',
      shortDescription: 'GTO, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'GTO',

      name: 'Guanajuato',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.HGO_MX,
      literal: 'HGO_MX',
      description: 'Hidalgo, Mexico',
      shortDescription: 'HGO, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'HGO',

      name: 'Hidalgo',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.JAL_MX,
      literal: 'JAL_MX',
      description: 'Jalisco, Mexico',
      shortDescription: 'JAL, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'JAL',

      name: 'Jalisco',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MCH_MX,
      literal: 'MCH_MX',
      description: 'Michoacán, Mexico',
      shortDescription: 'MCH, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'MCH',

      name: 'Michoacán',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MEX_MX,
      literal: 'MEX_MX',
      description: 'Estado De México, Mexico',
      shortDescription: 'MEX, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'MEX',

      name: 'Estado De México',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MOR_MX,
      literal: 'MOR_MX',
      description: 'Morelos, Mexico',
      shortDescription: 'MOR, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'MOR',

      name: 'Morelos',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NL_MX,
      literal: 'NL_MX',
      description: 'Nuevo Léon, Mexico',
      shortDescription: 'NL, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'NL',

      name: 'Nuevo Léon',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.OAX_MX,
      literal: 'OAX_MX',
      description: 'Oaxaca, Mexico',
      shortDescription: 'OAX, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'OAX',

      name: 'Oaxaca',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PUE_MX,
      literal: 'PUE_MX',
      description: 'Puebla, Mexico',
      shortDescription: 'PUE, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'PUE',

      name: 'Puebla',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.QR_MX,
      literal: 'QR_MX',
      description: 'Quintana Roo, Mexico',
      shortDescription: 'QR, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'QR',

      name: 'Quintana Roo',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.QRO_MX,
      literal: 'QRO_MX',
      description: 'Querétaro, Mexico',
      shortDescription: 'QRO, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'QRO',

      name: 'Querétaro',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SIN_MX,
      literal: 'SIN_MX',
      description: 'Sinaloa, Mexico',
      shortDescription: 'SIN, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'SIN',

      name: 'Sinaloa',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SLP_MX,
      literal: 'SLP_MX',
      description: 'San Luis Potosí, Mexico',
      shortDescription: 'SLP, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'SLP',

      name: 'San Luis Potosí',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SON_MX,
      literal: 'SON_MX',
      description: 'Sonora, Mexico',
      shortDescription: 'SON, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'SON',

      name: 'Sonora',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TAB_MX,
      literal: 'TAB_MX',
      description: 'Tabasco, Mexico',
      shortDescription: 'TAB, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'TAB',

      name: 'Tabasco',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TLX_MX,
      literal: 'TLX_MX',
      description: 'Tlaxcala, Mexico',
      shortDescription: 'TLX, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'TLX',

      name: 'Tlaxcala',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TMS_MX,
      literal: 'TMS_MX',
      description: 'Tamaulipas, Mexico',
      shortDescription: 'TMS, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'TMS',

      name: 'Tamaulipas',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.VER_MX,
      literal: 'VER_MX',
      description: 'Veracruz, Mexico',
      shortDescription: 'VER, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'VER',

      name: 'Veracruz',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.YUC_MX,
      literal: 'YUC_MX',
      description: 'Yucatán, Mexico',
      shortDescription: 'YUC, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'YUC',

      name: 'Yucatán',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ZAC_MX,
      literal: 'ZAC_MX',
      description: 'Zacatecas, Mexico',
      shortDescription: 'ZAC, MX',
      listPriority: 0,

      countryCode: 147,

      standardCode: 'ZAC',

      name: 'Zacatecas',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.JOH_MY,
      literal: 'JOH_MY',
      description: 'Johor, Malaysia',
      shortDescription: 'JOH, MY',
      listPriority: 0,

      countryCode: 148,

      standardCode: 'JOH',

      name: 'Johor',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.KED_MY,
      literal: 'KED_MY',
      description: 'Kedah, Malaysia',
      shortDescription: 'KED, MY',
      listPriority: 0,

      countryCode: 148,

      standardCode: 'KED',

      name: 'Kedah',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.KEL_MY,
      literal: 'KEL_MY',
      description: 'Kelantan, Malaysia',
      shortDescription: 'KEL, MY',
      listPriority: 0,

      countryCode: 148,

      standardCode: 'KEL',

      name: 'Kelantan',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.KUL_MY,
      literal: 'KUL_MY',
      description: 'Kuala Lumpur, Malaysia',
      shortDescription: 'KUL, MY',
      listPriority: 0,

      countryCode: 148,

      standardCode: 'KUL',

      name: 'Kuala Lumpur',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LAB_MY,
      literal: 'LAB_MY',
      description: 'Labuan, Malaysia',
      shortDescription: 'LAB, MY',
      listPriority: 0,

      countryCode: 148,

      standardCode: 'LAB',

      name: 'Labuan',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MEL_MY,
      literal: 'MEL_MY',
      description: 'Melaka, Malaysia',
      shortDescription: 'MEL, MY',
      listPriority: 0,

      countryCode: 148,

      standardCode: 'MEL',

      name: 'Melaka',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PAH_MY,
      literal: 'PAH_MY',
      description: 'Pahang, Malaysia',
      shortDescription: 'PAH, MY',
      listPriority: 0,

      countryCode: 148,

      standardCode: 'PAH',

      name: 'Pahang',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PEL_MY,
      literal: 'PEL_MY',
      description: 'Perlis, Malaysia',
      shortDescription: 'PEL, MY',
      listPriority: 0,

      countryCode: 148,

      standardCode: 'PEL',

      name: 'Perlis',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PER_MY,
      literal: 'PER_MY',
      description: 'Perak, Malaysia',
      shortDescription: 'PER, MY',
      listPriority: 0,

      countryCode: 148,

      standardCode: 'PER',

      name: 'Perak',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PIN_MY,
      literal: 'PIN_MY',
      description: 'Pulau Pinang, Malaysia',
      shortDescription: 'PIN, MY',
      listPriority: 0,

      countryCode: 148,

      standardCode: 'PIN',

      name: 'Pulau Pinang',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SAB_MY,
      literal: 'SAB_MY',
      description: 'Sabah, Malaysia',
      shortDescription: 'SAB, MY',
      listPriority: 0,

      countryCode: 148,

      standardCode: 'SAB',

      name: 'Sabah',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SAR_MY,
      literal: 'SAR_MY',
      description: 'Sarawak, Malaysia',
      shortDescription: 'SAR, MY',
      listPriority: 0,

      countryCode: 148,

      standardCode: 'SAR',

      name: 'Sarawak',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SEL_MY,
      literal: 'SEL_MY',
      description: 'Selangor, Malaysia',
      shortDescription: 'SEL, MY',
      listPriority: 0,

      countryCode: 148,

      standardCode: 'SEL',

      name: 'Selangor',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SER_MY,
      literal: 'SER_MY',
      description: 'Negeri Sembilan, Malaysia',
      shortDescription: 'SER, MY',
      listPriority: 0,

      countryCode: 148,

      standardCode: 'SER',

      name: 'Negeri Sembilan',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TRE_MY,
      literal: 'TRE_MY',
      description: 'Trengganu, Malaysia',
      shortDescription: 'TRE, MY',
      listPriority: 0,

      countryCode: 148,

      standardCode: 'TRE',

      name: 'Trengganu',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NI_NZ,
      literal: 'NI_NZ',
      description: 'North Island, New Zealand',
      shortDescription: 'NI, NZ',
      listPriority: 0,

      countryCode: 161,

      standardCode: 'NI',

      name: 'North Island',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SI_NZ,
      literal: 'SI_NZ',
      description: 'South Island, New Zealand',
      shortDescription: 'SI, NZ',
      listPriority: 0,

      countryCode: 161,

      standardCode: 'SI',

      name: 'South Island',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SE_SG,
      literal: 'SE_SG',
      description: 'Sg-East, Singapore',
      shortDescription: 'SE, SG',
      listPriority: 0,

      countryCode: 186,

      standardCode: 'SE',

      name: 'Sg-East',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SN_SG,
      literal: 'SN_SG',
      description: 'Sg-North, Singapore',
      shortDescription: 'SN, SG',
      listPriority: 0,

      countryCode: 186,

      standardCode: 'SN',

      name: 'Sg-North',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SS_SG,
      literal: 'SS_SG',
      description: 'Sg-South, Singapore',
      shortDescription: 'SS, SG',
      listPriority: 0,

      countryCode: 186,

      standardCode: 'SS',

      name: 'Sg-South',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SW_SG,
      literal: 'SW_SG',
      description: 'Sg-West, Singapore',
      shortDescription: 'SW, SG',
      listPriority: 0,

      countryCode: 186,

      standardCode: 'SW',

      name: 'Sg-West',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.C_TH,
      literal: 'C_TH',
      description: 'Central, Thailand',
      shortDescription: 'C, TH',
      listPriority: 0,

      countryCode: 204,

      standardCode: 'C',

      name: 'Central',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.E_TH,
      literal: 'E_TH',
      description: 'East, Thailand',
      shortDescription: 'E, TH',
      listPriority: 0,

      countryCode: 204,

      standardCode: 'E',

      name: 'East',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.N_TH,
      literal: 'N_TH',
      description: 'North, Thailand',
      shortDescription: 'N, TH',
      listPriority: 0,

      countryCode: 204,

      standardCode: 'N',

      name: 'North',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.S_TH,
      literal: 'S_TH',
      description: 'South, Thailand',
      shortDescription: 'S, TH',
      listPriority: 0,

      countryCode: 204,

      standardCode: 'S',

      name: 'South',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.W_TH,
      literal: 'W_TH',
      description: 'West, Thailand',
      shortDescription: 'W, TH',
      listPriority: 0,

      countryCode: 204,

      standardCode: 'W',

      name: 'West',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.KSH_TW,
      literal: 'KSH_TW',
      description: 'Kaoshung City, Taiwan',
      shortDescription: 'KSH, TW',
      listPriority: 0,

      countryCode: 214,

      standardCode: 'KSH',

      name: 'Kaoshung City',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TPE_TW,
      literal: 'TPE_TW',
      description: 'Taipei City, Taiwan',
      shortDescription: 'TPE, TW',
      listPriority: 0,

      countryCode: 214,

      standardCode: 'TPE',

      name: 'Taipei City',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TWN_TW,
      literal: 'TWN_TW',
      description: 'Taiwan Prov., Taiwan',
      shortDescription: 'TWN, TW',
      listPriority: 0,

      countryCode: 214,

      standardCode: 'TWN',

      name: 'Taiwan Prov.',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AA_US,
      literal: 'AA_US',
      description: 'Apo/fpo Aa, United States',
      shortDescription: 'AA, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'AA',

      name: 'Apo/fpo Aa',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AE_US,
      literal: 'AE_US',
      description: 'Apo/fpo Ae, United States',
      shortDescription: 'AE, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'AE',

      name: 'Apo/fpo Ae',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AK_US,
      literal: 'AK_US',
      description: 'Alaska, United States',
      shortDescription: 'AK, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'AK',

      name: 'Alaska',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AL_US,
      literal: 'AL_US',
      description: 'Alabama, United States',
      shortDescription: 'AL, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'AL',

      name: 'Alabama',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AP_US,
      literal: 'AP_US',
      description: 'Apo/fpo Ap, United States',
      shortDescription: 'AP, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'AP',

      name: 'Apo/fpo Ap',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AR_US,
      literal: 'AR_US',
      description: 'Arkansas, United States',
      shortDescription: 'AR, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'AR',

      name: 'Arkansas',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AS_US,
      literal: 'AS_US',
      description: 'American Samoa, United States',
      shortDescription: 'AS, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'AS',

      name: 'American Samoa',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AZ_US,
      literal: 'AZ_US',
      description: 'Arizona, United States',
      shortDescription: 'AZ, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'AZ',

      name: 'Arizona',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CA_US,
      literal: 'CA_US',
      description: 'California, United States',
      shortDescription: 'CA, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'CA',

      name: 'California',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CO_US,
      literal: 'CO_US',
      description: 'Colorado, United States',
      shortDescription: 'CO, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'CO',

      name: 'Colorado',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CT_US,
      literal: 'CT_US',
      description: 'Connecticut, United States',
      shortDescription: 'CT, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'CT',

      name: 'Connecticut',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.DC_US,
      literal: 'DC_US',
      description: 'District Of Columbia, United States',
      shortDescription: 'DC, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'DC',

      name: 'District Of Columbia',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.DE_US,
      literal: 'DE_US',
      description: 'Delaware, United States',
      shortDescription: 'DE, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'DE',

      name: 'Delaware',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.FL_US,
      literal: 'FL_US',
      description: 'Florida, United States',
      shortDescription: 'FL, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'FL',

      name: 'Florida',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GA_US,
      literal: 'GA_US',
      description: 'Georgia, United States',
      shortDescription: 'GA, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'GA',

      name: 'Georgia',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GU_US,
      literal: 'GU_US',
      description: 'Guam, United States',
      shortDescription: 'GU, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'GU',

      name: 'Guam',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.HI_US,
      literal: 'HI_US',
      description: 'Hawaii, United States',
      shortDescription: 'HI, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'HI',

      name: 'Hawaii',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.IA_US,
      literal: 'IA_US',
      description: 'Iowa, United States',
      shortDescription: 'IA, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'IA',

      name: 'Iowa',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ID_US,
      literal: 'ID_US',
      description: 'Idaho, United States',
      shortDescription: 'ID, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'ID',

      name: 'Idaho',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.IL_US,
      literal: 'IL_US',
      description: 'Illinois, United States',
      shortDescription: 'IL, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'IL',

      name: 'Illinois',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.IN_US,
      literal: 'IN_US',
      description: 'Indiana, United States',
      shortDescription: 'IN, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'IN',

      name: 'Indiana',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.KS_US,
      literal: 'KS_US',
      description: 'Kansas, United States',
      shortDescription: 'KS, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'KS',

      name: 'Kansas',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.KY_US,
      literal: 'KY_US',
      description: 'Kentucky, United States',
      shortDescription: 'KY, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'KY',

      name: 'Kentucky',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LA_US,
      literal: 'LA_US',
      description: 'Louisiana, United States',
      shortDescription: 'LA, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'LA',

      name: 'Louisiana',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MA_US,
      literal: 'MA_US',
      description: 'Massachusetts, United States',
      shortDescription: 'MA, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'MA',

      name: 'Massachusetts',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MD_US,
      literal: 'MD_US',
      description: 'Maryland, United States',
      shortDescription: 'MD, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'MD',

      name: 'Maryland',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ME_US,
      literal: 'ME_US',
      description: 'Maine, United States',
      shortDescription: 'ME, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'ME',

      name: 'Maine',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MI_US,
      literal: 'MI_US',
      description: 'Michigan, United States',
      shortDescription: 'MI, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'MI',

      name: 'Michigan',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MN_US,
      literal: 'MN_US',
      description: 'Minnesota, United States',
      shortDescription: 'MN, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'MN',

      name: 'Minnesota',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MO_US,
      literal: 'MO_US',
      description: 'Missouri, United States',
      shortDescription: 'MO, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'MO',

      name: 'Missouri',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MP_US,
      literal: 'MP_US',
      description: 'Northern Mariana Isl, United States',
      shortDescription: 'MP, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'MP',

      name: 'Northern Mariana Isl',

      isRelevant: false,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MS_US,
      literal: 'MS_US',
      description: 'Mississippi, United States',
      shortDescription: 'MS, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'MS',

      name: 'Mississippi',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MT_US,
      literal: 'MT_US',
      description: 'Montana, United States',
      shortDescription: 'MT, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'MT',

      name: 'Montana',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NC_US,
      literal: 'NC_US',
      description: 'North Carolina, United States',
      shortDescription: 'NC, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'NC',

      name: 'North Carolina',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ND_US,
      literal: 'ND_US',
      description: 'North Dakota, United States',
      shortDescription: 'ND, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'ND',

      name: 'North Dakota',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NE_US,
      literal: 'NE_US',
      description: 'Nebraska, United States',
      shortDescription: 'NE, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'NE',

      name: 'Nebraska',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NH_US,
      literal: 'NH_US',
      description: 'New Hampshire, United States',
      shortDescription: 'NH, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'NH',

      name: 'New Hampshire',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NJ_US,
      literal: 'NJ_US',
      description: 'New Jersey, United States',
      shortDescription: 'NJ, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'NJ',

      name: 'New Jersey',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NM_US,
      literal: 'NM_US',
      description: 'New Mexico, United States',
      shortDescription: 'NM, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'NM',

      name: 'New Mexico',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NV_US,
      literal: 'NV_US',
      description: 'Nevada, United States',
      shortDescription: 'NV, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'NV',

      name: 'Nevada',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NY_US,
      literal: 'NY_US',
      description: 'New York, United States',
      shortDescription: 'NY, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'NY',

      name: 'New York',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.OH_US,
      literal: 'OH_US',
      description: 'Ohio, United States',
      shortDescription: 'OH, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'OH',

      name: 'Ohio',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.OK_US,
      literal: 'OK_US',
      description: 'Oklahoma, United States',
      shortDescription: 'OK, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'OK',

      name: 'Oklahoma',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.OR_US,
      literal: 'OR_US',
      description: 'Oregon, United States',
      shortDescription: 'OR, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'OR',

      name: 'Oregon',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PA_US,
      literal: 'PA_US',
      description: 'Pennsylvania, United States',
      shortDescription: 'PA, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'PA',

      name: 'Pennsylvania',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PR_US,
      literal: 'PR_US',
      description: 'Puerto Rico, United States',
      shortDescription: 'PR, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'PR',

      name: 'Puerto Rico',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.RI_US,
      literal: 'RI_US',
      description: 'Rhode Island, United States',
      shortDescription: 'RI, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'RI',

      name: 'Rhode Island',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SC_US,
      literal: 'SC_US',
      description: 'South Carolina, United States',
      shortDescription: 'SC, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'SC',

      name: 'South Carolina',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SD_US,
      literal: 'SD_US',
      description: 'South Dakota, United States',
      shortDescription: 'SD, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'SD',

      name: 'South Dakota',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TN_US,
      literal: 'TN_US',
      description: 'Tennessee, United States',
      shortDescription: 'TN, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'TN',

      name: 'Tennessee',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TX_US,
      literal: 'TX_US',
      description: 'Texas, United States',
      shortDescription: 'TX, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'TX',

      name: 'Texas',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.UT_US,
      literal: 'UT_US',
      description: 'Utah, United States',
      shortDescription: 'UT, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'UT',

      name: 'Utah',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.VA_US,
      literal: 'VA_US',
      description: 'Virginia, United States',
      shortDescription: 'VA, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'VA',

      name: 'Virginia',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.VI_US,
      literal: 'VI_US',
      description: 'Virgin Islands, United States',
      shortDescription: 'VI, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'VI',

      name: 'Virgin Islands',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.VT_US,
      literal: 'VT_US',
      description: 'Vermont, United States',
      shortDescription: 'VT, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'VT',

      name: 'Vermont',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WA_US,
      literal: 'WA_US',
      description: 'Washington, United States',
      shortDescription: 'WA, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'WA',

      name: 'Washington',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WI_US,
      literal: 'WI_US',
      description: 'Wisconsin, United States',
      shortDescription: 'WI, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'WI',

      name: 'Wisconsin',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WV_US,
      literal: 'WV_US',
      description: 'West Virginia, United States',
      shortDescription: 'WV, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'WV',

      name: 'West Virginia',

      isRelevant: true,

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WY_US,
      literal: 'WY_US',
      description: 'Wyoming, United States',
      shortDescription: 'WY, US',
      listPriority: 0,

      countryCode: 219,

      standardCode: 'WY',

      name: 'Wyoming',

      isRelevant: true,

      typeName: "StateProvince"
   }
]

export class StateProvince implements IDomainModel {
   code: StateProvince_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   countryCode: number

   standardCode: string

   name: string

   isRelevant: boolean

   typeName: string

   static toDomainModel(code: StateProvince_): StateProvince {
      return StateProvinces.find(d => d.code === code)
   }
}
